(function($) {
    'use strict';

    var YMMConfig = {
        apiBaseUrl: window.YMM_API_BASE_URL || '/apps/ymm/dnj-ymm-dev',
        
        selectors: {
            yearDropdown: '.ymm-year',
            makeDropdown: '.ymm-make',
            modelDropdown: '.ymm-model',
            engineDropdown: '.ymm-engine',
            partTypeDropdown: '.ymm-part-type',
            searchButton: '.ymm-search',
            resetButton: '.ymm-reset-home',
            loader: '.bundle-loader',
            productContainer: '.productgrid--items',
            pagination: '.ymm-pagination',
            paginateInfo: '.ymm-paginate',
            viewToggle: '.utils-viewtoggle-button',
            ymmFoot: '.ymm-foot',
            paginationShowBy: '.utils-showby'
        },
        
        defaults: {
            viewMode: 'list-view',
            pageLimit: 25,
            pageNo: 1,
            cookieExpireDays: 3,
            maxRecentSearches: 5
        },
        
        // Available pagination options (must match Liquid template)
        paginationOptions: [25, 75, 100, 150, 200],
        
        placeholderImage: 'https://cdn.shopify.com/s/files/1/0596/8363/5395/files/dnj_placeholder_6.jpg?v=1653382342',
        
        configurablePrefixes: ['EK', 'RRK', 'PRK', 'P', 'PR', 'RB', 'MB', 'HGB', 'LFK', 'FGK', 'VK'],
        
        spinnerImage: 'https://cdn.shopify.com/s/files/1/0281/6924/0651/t/12/assets/spinner.gif',
        
        hideZeroPrice: typeof window.YMM_HIDE_ZERO_PRICE !== 'undefined' ? window.YMM_HIDE_ZERO_PRICE : false,
        
        hideOos: typeof window.YMM_HIDE_OOS !== 'undefined' ? window.YMM_HIDE_OOS : false
    };

    var YMMAPI = {
        fetch: function(params) {
            var self = this;
            return new Promise(function(resolve, reject) {
                var url = new URL(YMMConfig.apiBaseUrl, window.location.origin);
                Object.keys(params).forEach(function(key) {
                    if (params[key] !== null && params[key] !== undefined && params[key] !== '') {
                        url.searchParams.set(key, params[key]);
                    }
                });
                
                $.ajax({
                    url: url.toString(),
                    type: 'GET',
                    dataType: 'json',
                    success: function(data) {
                        resolve(data);
                    },
                    error: function(xhr, status, error) {
                        console.error('[YMM API] Fetch error:', error, 'Status:', status, 'Response:', xhr.responseText);
                        reject(new Error('API Error: ' + status));
                    }
                });
            });
        },
        
        getYears: function() {
            return this.fetch({ type: 'ajax', model: 'year', format: 'json' });
        },
        
        getMakes: function(yearId) {
            return this.fetch({ type: 'ajax', model: 'make', part_year: yearId, format: 'json' });
        },
        
        getModels: function(makeId) {
            return this.fetch({ type: 'ajax', model: 'model', part_make: makeId, format: 'json' });
        },
        
        getEngines: function(modelId) {
            return this.fetch({ type: 'ajax', model: 'engine', part_model: modelId, format: 'json' });
        },
        
        getPartTypes: function(params) {
            return this.fetch({
                type: 'ajax',
                model: 'part_type',
                ymm_year: params.year,
                ymm_make: params.make,
                ymm_model: params.model,
                ymm_engine: params.engine,
                part_engine: params.engineId,
                format: 'json'
            });
        },
        
        getProducts: function(params) {
            var apiParams = {
                type: 'ajax',
                ymm_part: 'parts',
                ymm_year: params.year,
                ymm_make: params.make,
                ymm_model: params.model,
                ymm_engine: params.engine,
                ymm_part_type: params.partType,
                page_limit: params.pageLimit || YMMConfig.defaults.pageLimit,
                page_no: params.pageNo || YMMConfig.defaults.pageNo,
                customerId: params.customerId || '',
                format: 'json'
            };
            
            return this.fetch(apiParams);
        },
        
        getAllProducts: function(params) {
            return this.fetch({
                type: 'ajax',
                part_items: 'parts',
                page_limit: params.pageLimit || YMMConfig.defaults.pageLimit,
                page_no: params.pageNo || YMMConfig.defaults.pageNo,
                customerId: params.customerId || '',
                format: 'json'
            });
        },
        
        getCustomerPrice: function(productId, customerId) {
            return this.fetch({
                type: 'ajax',
                action: 'getprice',
                product_id: productId,
                customer_id: customerId
            });
        }
    };

    var YMMUtils = {
        setCookie: function(name, value, days) {
            days = days || YMMConfig.defaults.cookieExpireDays;
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + date.toUTCString() + '; path=/';
        },
        
        getCookie: function(name) {
            var nameEQ = name + '=';
            var cookies = document.cookie.split(';');
            for (var i = 0; i < cookies.length; i++) {
                var cookie = cookies[i].trim();
                if (cookie.indexOf(nameEQ) === 0) {
                    return decodeURIComponent(cookie.substring(nameEQ.length));
                }
            }
            return null;
        },
        
        getUrlParam: function(param) {
            var params = new URLSearchParams(window.location.search);
            var value = params.get(param);
            if (value) {
                value = value.replace(/\+/g, ' ');
                return decodeURIComponent(value);
            }
            return undefined;
        },
        
        buildUrl: function(baseUrl, params) {
            var url = new URL(baseUrl, window.location.origin);
            Object.keys(params).forEach(function(key) {
                if (params[key] !== null && params[key] !== undefined && params[key] !== '') {
                    url.searchParams.set(key, params[key]);
                }
            });
            return url.toString();
        },
        
        buildQueryString: function(params) {
            var urlParams = new URLSearchParams();
            Object.keys(params).forEach(function(key) {
                if (params[key] !== null && params[key] !== undefined && params[key] !== '') {
                    urlParams.set(key, params[key]);
                }
            });
            return urlParams.toString();
        },
        
        isLoggedIn: function() {
            return typeof __st !== 'undefined' && __st.cid !== undefined;
        },
        
        getCustomerId: function() {
            if (typeof meta !== 'undefined' && meta.page && meta.page.customerId) {
                return meta.page.customerId;
            }
            return null;
        },
        
        isHomePage: function() {
            return $('body').hasClass('template-index');
        },
        
        isCatalogPage: function() {
            return $('body').hasClass('template-collection') && $('body.template-collection').attr('id') === 'catalog';
        },
        
        isProductPage: function() {
            return $('body').hasClass('template-product');
        },
        
        isSearchPage: function() {
            return $('body').hasClass('template-search');
        },
        
        isCollectionPage: function() {
            return $('body').hasClass('template-collection') && $('body.template-collection').attr('id') !== 'catalog';
        },
        
        formatPrice: function(amount) {
            var num = parseFloat(amount);
            if (isNaN(num)) return '$0.00';
            return '$' + num.toFixed(2);
        },

        parsePriceValue: function(value) {
            if (value === null || typeof value === 'undefined') return NaN;
            var normalized = String(value).replace(/[^0-9.-]/g, '');
            return parseFloat(normalized);
        },

        getCatalogProductPrice: function(product) {
            if (!product) return NaN;

            var price = this.parsePriceValue(product.price);
            var pricelist = product.pricelist;

            if (pricelist && pricelist.discount_type) {
                var discountValue = this.parsePriceValue(pricelist.discount_value);

                if (pricelist.discount_type === 'fixed') {
                    return isNaN(discountValue) ? price : discountValue;
                }

                if (pricelist.discount_type === 'percentage') {
                    if (isNaN(price) || isNaN(discountValue)) {
                        return price;
                    }
                    return price - (price * discountValue / 100);
                }
            }

            return price;
        },

        hasPositiveCatalogPrice: function(product) {
            var price = this.getCatalogProductPrice(product);
            return !isNaN(price) && price > 0;
        },
        
        calculateDiscount: function(price, discountValue, discountType) {
            var originalPrice = parseFloat(price);
            var discount = parseFloat(discountValue);
            
            if (isNaN(originalPrice) || isNaN(discount)) return originalPrice;
            
            if (discountType === 'fixed') {
                return discount;
            } else if (discountType === 'percentage') {
                return originalPrice - (originalPrice * discount / 100);
            }
            return originalPrice;
        },
        
        getSkuPrefix: function(sku) {
            if (!sku) return '';
            return sku.split(/[0-9]/)[0].toUpperCase();
        },
        
        isConfigurableSku: function(sku) {
            var prefix = this.getSkuPrefix(sku);
            return YMMConfig.configurablePrefixes.indexOf(prefix) !== -1;
        },
        
        generateUniqueId: function() {
            return Math.floor(Math.random() * 50000) + Date.now();
        },
        
        escapeHtml: function(text) {
            if (!text) return '';
            var div = document.createElement('div');
            div.textContent = text;
            return div.innerHTML;
        },
        
        showLoader: function() {
            $(YMMConfig.selectors.loader).css('display', 'flex');
        },
        
        hideLoader: function() {
            $(YMMConfig.selectors.loader).css('display', 'none');
        },
        
        getRecentSearches: function() {
            var searches = this.getCookie('searches');
            if (searches) {
                try {
                    return JSON.parse(searches);
                } catch (e) {
                    return [];
                }
            }
            return [];
        },
        
        addRecentSearch: function(searchUrl) {
            var searches = this.getRecentSearches();
            var index = searches.indexOf(searchUrl);
            if (index !== -1) {
                searches.splice(index, 1);
            }
            searches.unshift(searchUrl);
            if (searches.length > YMMConfig.defaults.maxRecentSearches) {
                searches = searches.slice(0, YMMConfig.defaults.maxRecentSearches);
            }
            this.setCookie('searches', JSON.stringify(searches));
        },
        
        hasYMMParams: function() {
            var params = ['ymm_year', 'ymm_make', 'ymm_model', 'ymm_engine', 'ymm_part_type'];
            for (var i = 0; i < params.length; i++) {
                if (this.getUrlParam(params[i])) {
                    return true;
                }
            }
            return false;
        },
        
        getYMMParams: function() {
            var params = {
                year: this.getUrlParam('ymm_year'),
                make: this.getUrlParam('ymm_make'),
                model: this.getUrlParam('ymm_model'),
                engine: this.getUrlParam('ymm_engine'),
                partType: this.getUrlParam('ymm_part_type'),
                pageNo: parseInt(this.getUrlParam('p')) || YMMConfig.defaults.pageNo,
                pageLimit: parseInt(this.getUrlParam('product_limit')) || YMMConfig.defaults.pageLimit,
                viewMode: this.getUrlParam('grid_list') || YMMConfig.defaults.viewMode,
                id: this.getUrlParam('id')
            };
            
            return params;
        },
        
        getCurrentViewMode: function() {
            var $activeView = $(YMMConfig.selectors.viewToggle + '.active');
            if ($activeView.length) {
                return $activeView.data('collection-view') || YMMConfig.defaults.viewMode;
            }
            return this.getUrlParam('grid_list') || YMMConfig.defaults.viewMode;
        }
    };

    var YMMDropdown = {
        state: {
            year: null,
            yearText: null,
            make: null,
            makeText: null,
            model: null,
            modelText: null,
            engine: null,
            engineText: null,
            partType: null,
            partTypeText: null,
            isInitializing: false,
            isCascading: false
        },
        
        placeholders: {
            year: 'Year',
            make: 'Make',
            model: 'Model',
            engine: 'Engine',
            partType: 'View all parts'
        },
        
        initialize: function() {
            var self = this;
            this.state.isInitializing = true;
            this.state.isCascading = true;
            
            var urlParams = YMMUtils.getYMMParams();
            
            YMMAPI.getYears()
                .then(function(data) {
                    self.populateDropdown('year', data, urlParams.year);
                    
                    if (urlParams.year) {
                        return self.handleYearChange(self.getValueIdByName('year', urlParams.year), urlParams);
                    }
                    return Promise.resolve();
                })
                .then(function() {
                    self.state.isInitializing = false;
                    self.state.isCascading = false;
                })
                .catch(function(error) {
                    console.error('Dropdown initialization failed:', error);
                    self.state.isInitializing = false;
                    self.state.isCascading = false;
                });
        },
        
        handleYearChange: function(yearId, urlParams) {
            var self = this;
            urlParams = urlParams || {};
            
            this.state.year = yearId;
            this.state.yearText = this.getSelectedText('year');
            this.resetDropdowns(['make', 'model', 'engine', 'partType']);
            
            if (!yearId || yearId === '0') {
                this.updateDropdownState('year', true);
                this.updateSearchButtonState();
                return Promise.resolve();
            }
            
            this.updateDropdownState('year', false);
            this.updateSearchButtonState();
            
            return YMMAPI.getMakes(yearId)
                .then(function(data) {
                    self.populateDropdown('make', data, urlParams.make);
                    self.updateDropdownState('make', true);
                    
                    if (data.length === 1) {
                        return self.handleMakeChange(data[0].value_id, urlParams);
                    }
                    
                    if (urlParams.make && self.state.isInitializing) {
                        var makeId = self.getValueIdByName('make', urlParams.make);
                        if (makeId) {
                            return self.handleMakeChange(makeId, urlParams);
                        }
                    }
                    return Promise.resolve();
                });
        },
        
        handleMakeChange: function(makeId, urlParams) {
            var self = this;
            urlParams = urlParams || {};
            
            this.state.make = makeId;
            this.state.makeText = this.getSelectedText('make');
            this.resetDropdowns(['model', 'engine', 'partType']);
            
            if (!makeId || makeId === '0') {
                this.updateDropdownState('make', true);
                this.updateSearchButtonState();
                return Promise.resolve();
            }
            
            this.updateDropdownState('make', false);
            this.updateSearchButtonState();
            
            return YMMAPI.getModels(makeId)
                .then(function(data) {
                    self.populateDropdown('model', data, urlParams.model);
                    self.updateDropdownState('model', true);
                    
                    if (data.length === 1) {
                        return self.handleModelChange(data[0].value_id, urlParams);
                    }
                    
                    if (urlParams.model && self.state.isInitializing) {
                        var modelId = self.getValueIdByName('model', urlParams.model);
                        if (modelId) {
                            return self.handleModelChange(modelId, urlParams);
                        }
                    }
                    return Promise.resolve();
                });
        },
        
        handleModelChange: function(modelId, urlParams) {
            var self = this;
            urlParams = urlParams || {};
            
            this.state.model = modelId;
            this.state.modelText = this.getSelectedText('model');
            this.resetDropdowns(['engine', 'partType']);
            
            if (!modelId || modelId === '0') {
                this.updateDropdownState('model', true);
                this.updateSearchButtonState();
                return Promise.resolve();
            }
            
            this.updateDropdownState('model', false);
            this.updateSearchButtonState();
            
            return YMMAPI.getEngines(modelId)
                .then(function(data) {
                    self.populateDropdown('engine', data, urlParams.engine);
                    self.updateDropdownState('engine', true);
                    
                    if (data.length === 1) {
                        return self.handleEngineChange(data[0].value_id, urlParams);
                    }
                    
                    if (urlParams.engine && self.state.isInitializing) {
                        var engineId = self.getValueIdByName('engine', urlParams.engine);
                        if (engineId) {
                            return self.handleEngineChange(engineId, urlParams);
                        }
                    }
                    return Promise.resolve();
                });
        },
        
        handleEngineChange: function(engineId, urlParams) {
            var self = this;
            urlParams = urlParams || {};
            
            this.state.engine = engineId;
            this.state.engineText = this.getSelectedText('engine');
            this.resetDropdowns(['partType']);
            
            if (!engineId || engineId === '0') {
                this.updateDropdownState('engine', true);
                this.updateSearchButtonState();
                return Promise.resolve();
            }
            
            this.updateDropdownState('engine', false);
            this.updateSearchButtonState();
            
            var apiParams = {
                year: this.state.yearText || this.getSelectedText('year'),
                make: this.state.makeText || this.getSelectedText('make'),
                model: this.state.modelText || this.getSelectedText('model'),
                engine: this.state.engineText || this.getSelectedText('engine'),
                engineId: engineId
            };
            
            return YMMAPI.getPartTypes(apiParams)
                .then(function(data) {
                    self.populateDropdown('partType', data, urlParams.partType);
                    self.updateDropdownState('partType', true);
                    return Promise.resolve();
                });
        },
        
        populateDropdown: function(type, data, selectedValue) {
            var selectorKey = type + 'Dropdown';
            var $dropdown = $(YMMConfig.selectors[selectorKey]);
            var placeholder = this.placeholders[type] || type.toUpperCase();
            
            var html = '<option value="0">' + placeholder + '</option>';
            
            for (var i = 0; i < data.length; i++) {
                var item = data[i];
                if (item.name && item.name !== '' && item.name !== placeholder) {
                    var isSelected = selectedValue && selectedValue.trim() === item.name.trim();
                    html += '<option value="' + item.value_id + '"' + (isSelected ? ' selected' : '') + '>' + item.name + '</option>';
                }
            }
            
            $dropdown.html(html);
        },
        
        resetDropdowns: function(types) {
            for (var i = 0; i < types.length; i++) {
                var type = types[i];
                var selectorKey = type + 'Dropdown';
                var $dropdown = $(YMMConfig.selectors[selectorKey]);
                var placeholder = this.placeholders[type] || type.toUpperCase();
                
                $dropdown.html('<option value="0">' + placeholder + '</option>');
                $dropdown.closest('.form-group').addClass('disabled').removeClass('active');
                
                this.state[type] = null;
                this.state[type + 'Text'] = null;
            }
        },
        
        updateDropdownState: function(type, isActive) {
            var selectorKey = type + 'Dropdown';
            var $dropdown = $(YMMConfig.selectors[selectorKey]);
            var $formGroup = $dropdown.closest('.form-group');
            
            if (isActive) {
                $formGroup.removeClass('disabled').addClass('active');
            } else {
                $formGroup.removeClass('active');
            }
        },
        
        updateSearchButtonState: function() {
            var $searchButtonContainer = $(YMMConfig.selectors.searchButton).closest('div');
            
            // Enable search button if Year, Make, Model, and Engine are all selected
            var yearSelected = this.getSelectedValue('year') && this.getSelectedValue('year') !== '0';
            var makeSelected = this.getSelectedValue('make') && this.getSelectedValue('make') !== '0';
            var modelSelected = this.getSelectedValue('model') && this.getSelectedValue('model') !== '0';
            var engineSelected = this.getSelectedValue('engine') && this.getSelectedValue('engine') !== '0';
            
            if (yearSelected && makeSelected && modelSelected && engineSelected) {
                $searchButtonContainer.removeClass('disabled');
            } else {
                $searchButtonContainer.addClass('disabled');
            }
        },
        
        getSelectedText: function(type) {
            var selectorKey = type + 'Dropdown';
            var $dropdown = $(YMMConfig.selectors[selectorKey]);
            var $option = $dropdown.find('option:selected');
            
            if ($option.val() !== '0' && $option.val() !== '') {
                return $option.text().trim();
            }
            return '';
        },
        
        getSelectedValue: function(type) {
            var selectorKey = type + 'Dropdown';
            var $dropdown = $(YMMConfig.selectors[selectorKey]);
            return $dropdown.val();
        },
        
        getValueIdByName: function(type, name) {
            if (!name) return null;
            
            var selectorKey = type + 'Dropdown';
            var $dropdown = $(YMMConfig.selectors[selectorKey]);
            var $options = $dropdown.find('option');
            
            for (var i = 0; i < $options.length; i++) {
                var $opt = $($options[i]);
                if ($opt.text().trim() === name.trim()) {
                    return $opt.val();
                }
            }
            return null;
        },
        
        reset: function() {
            this.resetDropdowns(['make', 'model', 'engine', 'partType']);
            $(YMMConfig.selectors.yearDropdown).val('0');
            this.state.year = null;
            this.state.yearText = null;
            $(YMMConfig.selectors.searchButton).closest('div').addClass('disabled');
        },
        
        getCurrentSelection: function() {
            return {
                year: this.getSelectedText('year'),
                yearId: this.getSelectedValue('year'),
                make: this.getSelectedText('make'),
                makeId: this.getSelectedValue('make'),
                model: this.getSelectedText('model'),
                modelId: this.getSelectedValue('model'),
                engine: this.getSelectedText('engine'),
                engineId: this.getSelectedValue('engine'),
                partType: this.getSelectedText('partType'),
                partTypeId: this.getSelectedValue('partType')
            };
        },
        
        navigateToCatalog: function() {
            var selection = this.getCurrentSelection();
            var params = {};
            var lastId = null;
            
            // Check if minimum required fields are selected (Year, Make, Model, Engine)
            if (!selection.year || !selection.make || !selection.model || !selection.engine) {
                return; // Don't navigate if minimum requirements aren't met
            }
            
            if (selection.year) {
                params.ymm_year = selection.year;
                lastId = selection.yearId;
            }
            if (selection.make) {
                params.ymm_make = selection.make;
                lastId = selection.makeId;
            }
            if (selection.model) {
                params.ymm_model = selection.model;
                lastId = selection.modelId;
            }
            if (selection.engine) {
                params.ymm_engine = selection.engine;
                lastId = selection.engineId;
            }
            // Part Type is now optional
            if (selection.partType && selection.partTypeId !== '0') {
                params.ymm_part_type = selection.partType;
                lastId = selection.partTypeId;
            }
            
            if (lastId) {
                params.id = lastId;
            }
            
            params.grid_list = YMMUtils.getCurrentViewMode();
            
            var queryString = YMMUtils.buildQueryString(params);
            
            if (queryString) {
                var searchUrl = '/collections/catalog?' + queryString;
                YMMUtils.addRecentSearch(searchUrl);
                window.location.href = searchUrl;
            }
        },
        
        bindEvents: function() {
            var self = this;
            
            // Prevent form submission
            $('.ymm-form form').on('submit', function(e) {
                e.preventDefault();
                self.navigateToCatalog();
                return false;
            });
            
            $(YMMConfig.selectors.yearDropdown).on('change', function() {
                if (self.state.isCascading) return;
                self.handleYearChange($(this).val());
            });
            
            $(YMMConfig.selectors.makeDropdown).on('change', function() {
                if (self.state.isCascading) return;
                self.handleMakeChange($(this).val());
            });
            
            $(YMMConfig.selectors.modelDropdown).on('change', function() {
                if (self.state.isCascading) return;
                self.handleModelChange($(this).val());
            });
            
            $(YMMConfig.selectors.engineDropdown).on('change', function() {
                if (self.state.isCascading) return;
                self.handleEngineChange($(this).val());
            });
            
            $(YMMConfig.selectors.partTypeDropdown).on('change', function() {
                self.navigateToCatalog();
            });
            
            $(YMMConfig.selectors.searchButton).on('click', function(e) {
                e.preventDefault();
                self.navigateToCatalog();
            });
            
            $(YMMConfig.selectors.resetButton).on('click', function(e) {
                e.preventDefault();
                self.reset();
            });
        }
    };

    var YMMTemplates = {
        addToCartIcon: '<span class="atc-button--text"><i class="fa fa-shopping-cart" aria-hidden="true"></i> ADD TO CART</span><span class="atc-button--icon"><svg aria-hidden="true" focusable="false" role="presentation" width="26" height="26" viewBox="0 0 26 26" xmlns="http://www.w3.org/2000/svg"><g fill-rule="nonzero" fill="currentColor"><path d="M13 26C5.82 26 0 20.18 0 13S5.82 0 13 0s13 5.82 13 13-5.82 13-13 13zm0-3.852a9.148 9.148 0 1 0 0-18.296 9.148 9.148 0 0 0 0 18.296z" opacity=".29"></path><path d="M13 26c7.18 0 13-5.82 13-13a1.926 1.926 0 0 0-3.852 0A9.148 9.148 0 0 1 13 22.148 1.926 1.926 0 0 0 13 26z"></path></g></svg></span>',
        
        getAddToCartText: function(product) {
            var productType = (product.product_type || '').toLowerCase();
            var bundleType = (product.bundle_type || '').toLowerCase();
            
            if (productType === 'simple' || productType === 'bundle' || bundleType === 'simple') {
                return this.addToCartIcon;
            }
            
            if (productType === 'configurable') {
                return this.addToCartIcon;
            }
            
            if (YMMUtils.isConfigurableSku(product.handle)) {
                return 'Choose size';
            }
            
            return this.addToCartIcon;
        },
        
        priceSection: function(product, isLoggedIn) {
            if (!isLoggedIn) return { html: '', propertiesHtml: '' };
            
            var jobberLabel = '';
            var customPriceHtml = '';
            var propertiesHtml = '';
            var pricelist = product.pricelist;
            var originalPrice = parseFloat(product.price);
            
            if (pricelist && typeof pricelist !== 'undefined' && pricelist.discount_type) {
                if (pricelist.discount_type === 'fixed') {
                    jobberLabel = 'Jobber Price : ';
                    customPriceHtml = '<div class="price__customcurrent" data-customprice-container><span class="money-label" data-price-label>Your Price :</span><span class="money 9" data-price=""> $' + parseFloat(pricelist.discount_value).toFixed(2) + '</span></div>';
                    propertiesHtml += '<input type="hidden" name="properties[_discountPrice]" data-property-name="_discountPrice" value="' + parseFloat(pricelist.discount_value).toFixed(2) + '">';
                    propertiesHtml += '<input type="hidden" name="properties[_discountType]" data-property-name="_discountType" value="' + pricelist.discount_type + '">';
                    propertiesHtml += '<input type="hidden" name="properties[_discountValue]" data-property-name="_discountValue" value="' + pricelist.discount_value + '">';
                } else if (pricelist.discount_type === 'percentage') {
                    jobberLabel = 'Jobber Price : ';
                    var discountAmount = originalPrice * parseFloat(pricelist.discount_value) / 100;
                    var priceDiscount = originalPrice - discountAmount;
                    customPriceHtml = '<div class="price__customcurrent" data-customprice-container><span class="money-label" data-price-label>Your Price :</span><span class="money 10" data-price=""> $' + parseFloat(priceDiscount).toFixed(2) + '</span></div>';
                    propertiesHtml += '<input type="hidden" name="properties[_discountPrice]" data-property-name="_discountPrice" value="' + parseFloat(priceDiscount).toFixed(2) + '">';
                    propertiesHtml += '<input type="hidden" name="properties[_discountType]" data-property-name="_discountType" value="' + pricelist.discount_type + '">';
                    propertiesHtml += '<input type="hidden" name="properties[_discountValue]" data-property-name="_discountValue" value="' + pricelist.discount_value + '">';
                    if (typeof pricelist.price_level !== 'undefined') {
                        propertiesHtml += '<input type="hidden" name="properties[_discountTag]" data-property-name="_discountTag" value="' + pricelist.price_level + '">';
                    } else {
                        propertiesHtml += '<input type="hidden" name="properties[_discountTag]" data-property-name="_discountTag" value="' + pricelist.tag + '">';
                    }
                }
            }
            
            var html = '<div class="product-item--price"><p class="h1 medium-down--left"><span class="visually-hidden">Regular price</span><small aria-hidden="true">' + jobberLabel + '$' + product.price + '</small><span class="visually-hidden">$ ' + product.price + '</span></p></div>' + customPriceHtml;
            
            return { html: html, propertiesHtml: propertiesHtml };
        },
        
        variantSelector: function(product, uqId) {
            var productType = (product.product_type || '').toLowerCase();
            var variantList = product.varient_list || [];
            var variantHtml = '';
            var optionHtml = '';
            
            if ((productType === 'configurable') && typeof variantList !== 'undefined' && variantList.length > 0) {
                variantHtml += '<div class="selector-wrapper" style="display:flex;"><label for="productSelect-product-template-option-0">Choose Size</label><select class="single-option-selector product_varient_select" data-uq=' + uqId + ' product_id=' + product.product_id + ' data-option="option1" id="productSelect-product-template-option-0">';
                variantHtml += '<option value="">Choose Size</option>';
                optionHtml += '<option value="">Choose Size</option>';
                
                for (var v = 0; v < variantList.length; v++) {
                    if (variantList[v].quantity > 0) {
                        if (product.ymm_sku === variantList[v].sku) {
                            optionHtml += '<option selected value="' + variantList[v].varient_id + '" data-title="' + variantList[v].title + '" data-sku="' + variantList[v].sku + '">' + variantList[v].title + '</option>';
                            variantHtml += '<option selected value="' + variantList[v].varient_id + '" data-title="' + variantList[v].title + '" data-sku="' + variantList[v].sku + '">' + variantList[v].title + '</option>';
                        } else {
                            optionHtml += '<option value="' + variantList[v].varient_id + '" data-title="' + variantList[v].title + '" data-sku="' + variantList[v].sku + '">' + variantList[v].title + '</option>';
                            variantHtml += '<option value="' + variantList[v].varient_id + '" data-title="' + variantList[v].title + '" data-sku="' + variantList[v].sku + '">' + variantList[v].title + '</option>';
                        }
                    }
                }
                variantHtml += '</select></div>';
            }
            
            var hiddenSelect = '<select name="id" id="productSelect-product-template" data-select-uq=' + uqId + ' class="product-variants product-variants-product-template product_varient_hidden_' + product.product_id + '" style="display: none;">';
            if (optionHtml) {
                hiddenSelect += optionHtml;
            } else {
                hiddenSelect += '<option selected="selected" data-sku="' + product.ymm_sku + '" value="' + product.varient_id + '">Default Title - $' + product.price + ' USD</option>';
            }
            hiddenSelect += '</select>';
            
            return { visible: variantHtml, hidden: hiddenSelect };
        },
        
        productMeta: function(product) {
            var ymmId = product.ymm_id || '';
            var html = '<div class="desc-highlight 1" id="desc_section_' + product.url + '_' + ymmId + '">';
            
            if (product.part_type != null && product.part_type !== '') {
                html += "<span class='part_type meta_val'><div><b>Part Type: </b></div><div>" + product.part_type + "</div></span>";
            }
            html += '<span id="desc_' + product.url + '"></span>';
            
            if (product.application != null && product.application !== '') {
                html += "<span class='application meta_val'><div><b>Application: </b></div><div>" + product.application + "</div></span>";
            }
            if (product.application_notes != null && product.application_notes !== '') {
                html += "<span class='application_notes meta_val'><div><b>Application Notes: </b></div><div>" + product.application_notes + "</div></span>";
            }
            if (YMMUtils.isCatalogPage()) {
                if (product.additional_notes != null && product.additional_notes !== '') {
                    html += "<span class='additional_notes meta_val'><div><b>Additional Notes: </b></div><div>" + YMMUtils.escapeHtml(product.additional_notes) + "</div></span>";
                }
                if (product.position != null && product.position !== '') {
                    html += "<span class='ymm_position meta_val'><div><b>Position: </b></div><div>" + YMMUtils.escapeHtml(product.position) + "</div></span>";
                }
            } else if (product.part_note != null && product.part_note !== '') {
                html += "<span class='part_note meta_val'><div><b>Part Notes: </b></div><div>" + product.part_note + "</div></span>";
            }
            if (product.qty_req != null && product.qty_req !== '') {
                html += "<span class='qty_req meta_val'><div><b>Qty Req: </b></div><div>" + product.qty_req + "</div></span>";
            }
            
            html += '</div>';
            return html;
        },

        catalogGridImageUrl: function(url, width) {
            if (!url || typeof url !== 'string') return url;
            width = width || 360;
            if (url.indexOf('cdn.shopify.com') === -1 && url.indexOf('shopifycdn') === -1) {
                return url;
            }
            if (/[?&]width=\d+/.test(url)) {
                return url.replace(/([?&])width=\d+/, '$1width=' + width);
            }
            if (/_[0-9]+x[0-9]*\.(jpe?g|png|webp|gif)/i.test(url)) {
                return url.replace(/_[0-9]+x[0-9]*(\.(jpe?g|png|webp|gif))/i, '_' + width + 'x$1');
            }
            return url + (url.indexOf('?') !== -1 ? '&' : '?') + 'width=' + width;
        },

        catalogGridImageSrcset: function(url) {
            return this.catalogGridImageUrl(url, 180) + ' 180w, ' +
                this.catalogGridImageUrl(url, 360) + ' 360w, ' +
                this.catalogGridImageUrl(url, 540) + ' 540w';
        },

        catalogGridImageTag: function(image, options, sizesPx) {
            var alt = YMMUtils.escapeHtml(options.imageAlt || '');
            sizesPx = sizesPx || '198px';
            var srcset = this.catalogGridImageSrcset(image);
            var src = this.catalogGridImageUrl(image, options.isFirstProduct ? 540 : 360);
            var tag = '<img class="grid-main-image ymm-grid-image" data-aspectratio="1.2" data-sizes="auto" alt="' + alt + '" sizes="' + sizesPx + '" width="198" height="165" decoding="async" srcset="' + srcset + '"';
            if (options.isFirstProduct) {
                return tag + ' loading="eager" fetchpriority="high" src="' + src + '">';
            }
            return tag + ' loading="lazy" src="' + src + '">';
        },
        
        productGridItem: function(product, options) {
            var isLoggedIn = options.isLoggedIn || false;
            var uqId = options.uqId || YMMUtils.generateUniqueId();
            var image = product.main_image || YMMConfig.placeholderImage;
            options.imageAlt = product.image_alt || '';
            var productType = (product.product_type || '').toLowerCase();
            var isBundle = productType === 'bundle' || product.bundle_type;
            var bundleType = product.bundle_type || '';
            
            var priceData = this.priceSection(product, isLoggedIn);
            var variants = this.variantSelector(product, uqId);
            var addToCartText = this.getAddToCartText(product);
            
            var productClasses = 'product-grid-item';
            if (isBundle) {
                productClasses += ' product-bundle';
            }
            
            var html = '<div class="grid-item small--one-half medium--one-quarter large--one-quarter">';
            html += '<div class="' + productClasses + '" attr-prod-id="' + product.product_id + '" attr-prod-sku="' + (product.handle || '') + '">';
            html += '<div class="product-grid-image" style="height: 216px;">';
            html += '<div class="product-grid-image--centered">';
            html += '<a href="/products/' + product.url + '">';
            html += '<div class="lazyload__image-wrapper no-js" style="max-width: 240px">';
            html += '<div style="padding-top:83.33333333333334%;">';
            html += this.catalogGridImageTag(image, options, '240px');
            html += '</div></div>';
            html += '<noscript><img src="" alt="' + (product.image_alt || '') + '" style="opacity:1;"></noscript>';
            html += '</a></div></div>';
            
            html += '<div class="title"><a href="/products/' + product.url + '">' + product.product_name + '</a></div>';
            html += '<div class="part-no">Part <span>#' + product.handle + '</span></div>';
            
            if (isLoggedIn) {
                var jobberLabel = '';
                var customPriceHtml = '';
                if (product.pricelist && product.pricelist.discount_type) {
                    jobberLabel = 'Jobber Price : ';
                    if (product.pricelist.discount_type === 'fixed') {
                        customPriceHtml = '<div class="price__customcurrent" data-customprice-container><span class="money-label" data-price-label>Your Price :</span><span class="money 9" data-price=""> $' + parseFloat(product.pricelist.discount_value).toFixed(2) + '</span></div>';
                    } else if (product.pricelist.discount_type === 'percentage') {
                        var discountedPrice = parseFloat(product.price) - (parseFloat(product.price) * parseFloat(product.pricelist.discount_value) / 100);
                        customPriceHtml = '<div class="price__customcurrent" data-customprice-container><span class="money-label" data-price-label>Your Price :</span><span class="money 10" data-price=""> $' + discountedPrice.toFixed(2) + '</span></div>';
                    }
                }
                html += '<div class="product-item--price"><span class="h1 medium--left"><span class="visually-hidden">Regular price</span><small aria-hidden="true">' + jobberLabel + '$' + product.price + '</small><span class="visually-hidden">$ ' + product.price + '</span></span></div>' + customPriceHtml;
            }
            
            html += '<div class="product-actions product-list-template">';
            html += '<form method="post" action="/cart/add" id="addToCartForm-product-template" accept-charset="UTF-8" class="customize-content addToCartForm addToCartForm--payment-button" enctype="multipart/form-data" data-product-form="">';
            html += '<input type="hidden" name="form_type" value="product"><input type="hidden" name="utf8" value="✓">';
            html += variants.visible;
            html += variants.hidden;
            
            if (isLoggedIn) {
                html += '<div class="quantity_parent_div"><div class="quantity_parent_child"><span class="qty_label">Qty: </span><span class="catalog--qty-adjuster catalog--js--minus" data-qty="0">-</span><input type="text" value="1" name="quantity" id="" class="" pattern="[0-9]*" onkeypress="return isNumber(event)"><span class="catalog--qty-adjuster catalog--js--add" data-qty="2">+</span></div></div>';
                
                if (isBundle && bundleType !== 'simple') {
                    html += '<button type="button" class="btn button-primary productitem--action-trigger" id="bundle-choose"><i class="fa fa-shopping-cart" aria-hidden="true"></i> Choose Size</button>';
                    html += '<button type="button" name="add" id="addToCart-product-template" class="btn btn--add-to-cart add-to-cart btn--secondary-accent is-added ' + productType + '-product hide-bundle-choose"><span id="addToCartText-product-template">' + addToCartText + '</span></button>';
                } else {
                    html += '<button type="button" name="add" id="addToCart-product-template" class="btn btn--add-to-cart add-to-cart btn--secondary-accent is-added ' + productType + '-product"><span id="addToCartText-product-template">' + addToCartText + '</span></button>';
                }
                html += '<a href="/products/' + product.url + '" class="btn see-more-info">See more info</a>';
            }
            
            html += '<div class="buyers-guide"><a class="buyers-guide-link" href="javascript: void(0);" data-prod-id="' + product.product_id + '">Buyers Guide</a><div class="buyers-guide-content" id="buyers_' + product.product_id + '"><h2>Buyers Guide: <span>' + product.product_name + '</span><a href="javascript: void(0);" class="close"><img src="//cdn.shopify.com/s/files/1/0454/6304/4257/t/2/assets/close.svg?v=12198423699971312732" alt="" title=""></a></h2><table class="scroll_compact"><thead><tr><th>Year</th><th>Make</th><th>Model</th><th>Engine</th></tr></thead><tbody><tr><td colspan="4" class="loading-spin"><img src="https://cdn.shopify.com/s/files/1/0281/6924/0651/t/12/assets/spinner.gif"></td></tr></tbody></table></div>' + (priceData.propertiesHtml || '') + '</div></form></div></div>';
            
            html += '<div class="location_table" data-location-link="' + product.url + '" id="location_table_uq_' + uqId + '" data-location-uq="' + uqId + '" onclick="get_variant_location()"><main><details><summary onclick="get_location_availability(\'' + (product.varient_id || '') + '\', this.getAttribute(\'class\'), this)" class="check_location_' + (product.varient_id || '') + '" id="' + (product.varient_id || '') + '"><h6>Check Availability <i class="location-icon material-icons">&#xe567;</i></h6></summary><div class="location_section location_section_' + (product.varient_id || '') + '"><div class="location_loader"><img src="https://cdn.shopify.com/s/files/1/0281/6924/0651/t/12/assets/spinner.gif" height="30px" alt="location loader"></div></div></details></main></div></div></div>';
            
            return html;
        },
        
        productListItem: function(product, options) {
            var isLoggedIn = options.isLoggedIn || false;
            var uqId = options.uqId || YMMUtils.generateUniqueId();
            var searchString = options.searchString || '';
            var image = product.main_image || YMMConfig.placeholderImage;
            options.imageAlt = product.image_alt || '';
            var productType = (product.product_type || '').toLowerCase();
            var isBundle = productType === 'bundle' || product.bundle_type;
            var bundleType = product.bundle_type || '';
            
            var priceData = this.priceSection(product, isLoggedIn);
            var variants = this.variantSelector(product, uqId);
            var addToCartText = this.getAddToCartText(product);
            var descHighlight = this.productMeta(product);
            
            var productClasses = 'product-grid-item product-list-item line-' + uqId;
            if (isBundle) {
                productClasses += ' product-bundle';
            }
            
            var html = '<div class="grid-item">';
            html += '<div class="' + productClasses + '" attr-prod-id="' + product.product_id + '" attr-prod-sku="' + (product.handle || '') + '">';
            html += '<div class="grid">';
            
            html += '<div class="grid-item large--one-fifth medium--one-third">';
            html += '<div class="product-list-image">';
            html += '<a href="/products/' + product.url + searchString + '">';
            html += '<div class="lazyload__image-wrapper" style="padding-top:83.33333333333334%;">';
            html += this.catalogGridImageTag(image, options, '198px');
            html += '</div></a>';
            html += '<noscript><img src="' + image + '" srcset="' + image + '" alt="' + YMMUtils.escapeHtml(product.image_alt || '') + '" style="opacity:1;"></noscript>';
            html += '</div></div>';
            
            html += '<div class="grid-item large--three-fifths medium--two-thirds">';
            html += '<p class="h6"><a href="/products/' + product.url + searchString + '">' + product.product_name + '</a></p>';
            html += '<div class="part-no">Part <span>#' + product.handle + '</span></div>';
            
            if (isLoggedIn && priceData.html) {
                html += priceData.html;
            }
            
            html += '<div class="product-actions product-list-template">';
            html += '<form method="post" action="/cart/add" id="addToCartForm-product-template" accept-charset="UTF-8" class="customize-content addToCartForm addToCartForm--payment-button" enctype="multipart/form-data" data-product-form="">';
            html += '<input type="hidden" name="form_type" value="product"><input type="hidden" name="utf8" value="✓">';
            html += variants.visible;
            html += variants.hidden;
            
            if (isLoggedIn) {
                html += '<div class="quantity_parent_div"><div class="quantity_parent_child"><span class="qty_label">Qty: </span><span class="catalog--qty-adjuster catalog--js--minus" data-qty="0">-</span><input type="text" value="1" name="quantity" id="" class="" pattern="[0-9]*" onkeypress="return isNumber(event)"><span class="catalog--qty-adjuster catalog--js--add" data-qty="2">+</span></div></div>';
                
                if (isBundle && bundleType !== 'simple') {
                    html += '<button type="button" class="btn button-primary productitem--action-trigger" id="bundle-choose"><i class="fa fa-shopping-cart" aria-hidden="true"></i> Choose Size</button>';
                    html += '<button type="button" class="btn add-to-cart ' + productType + '-product hide-bundle-choose" id="addToCart-product-template">' + addToCartText + '</button>';
                } else {
                    html += '<button type="button" class="btn add-to-cart ' + productType + '-product" id="addToCart-product-template">' + addToCartText + '</button>';
                }
                html += '<a href="/products/' + product.url + '" class="btn see-more-info">See more info <img src="//cdn.shopify.com/s/files/1/0454/6304/4257/t/2/assets/arrow-right.svg?v=13848028441984674738" alt="" title="" class="icon"></a>';
            }
            
            html += '<div class="buyers-guide"><a class="buyers-guide-link" href="javascript: void(0);" data-prod-id="' + product.product_id + '">Buyers Guide</a><div class="buyers-guide-content" id="buyers_' + product.product_id + '"><h2>Buyers Guide: <span>' + product.product_name + '</span><a href="javascript: void(0);" class="close"><img src="//cdn.shopify.com/s/files/1/0454/6304/4257/t/2/assets/close.svg?v=12198423699971312732" alt="" title=""></a></h2><table  class="scroll_compact"><thead><tr><th>Year</th><th>Make</th><th>Model</th><th>Engine</th></tr></thead><tbody><tr><td colspan="4" class="loading-spin"><img src="https://cdn.shopify.com/s/files/1/0281/6924/0651/t/12/assets/spinner.gif"></td></tr></tbody></table></div></div>' + (priceData.propertiesHtml || '') + '</div></form></div><div class="grid-item large--one-fifth medium--two-thirds"><div class="product-details">' + descHighlight + '</div></div></div>';
            html += '<div class="location_table" data-location-link="' + product.url + '" id="location_table_uq_' + uqId + '" data-location-uq="' + uqId + '" onclick="get_variant_location()"><main><details><summary onclick="get_location_availability(\'' + (product.varient_id || '') + '\', this.getAttribute(\'class\'), this)" class="check_location_' + (product.varient_id || '') + '" id="' + (product.varient_id || '') + '"><h6>Check Availability <i class="location-icon material-icons">&#xe567;</i></h6></summary><div class="location_section location_section_' + (product.varient_id || '') + '"><div class="location_loader"><img src="https://cdn.shopify.com/s/files/1/0281/6924/0651/t/12/assets/spinner.gif" height="30px" alt="location loader"></div></div></details></main></div></div></div>';
            
            return html;
        },
        
        productOutOfStock: function(product, options) {
            var viewMode = options.viewMode || 'list-view';
            var uqId = options.uqId || YMMUtils.generateUniqueId();
            var searchString = options.searchString || '';
            var image = product.main_image || YMMConfig.placeholderImage;
            options.imageAlt = product.image_alt || '';
            var isLoggedIn = options.isLoggedIn || false;
            var variantId = product.varient_id || '';
            var priceData = this.priceSection(product, isLoggedIn);
            var formattedPrice = product.pricelist && product.pricelist.final_price 
                ? parseFloat(product.pricelist.final_price).toFixed(2) 
                : parseFloat(product.price || 0).toFixed(2);
            
            if (viewMode === 'grid-view') {
                var html = '<div class="grid-item small--one-half medium--one-quarter large--one-quarter">';
                html += '<div class="product-grid-item out-of-stock-item" attr-prod-id="' + product.product_id + '">';
                html += '<div class="product-grid-image" style="height: 216px;">';
                html += '<div class="product-grid-image--centered">';
                html += '<a href="/products/' + product.url + '">';
                html += '<div class="lazyload__image-wrapper no-js" style="max-width: 240px">';
                html += '<div style="padding-top:83.33333333333334%;">';
                html += this.catalogGridImageTag(image, options, '240px');
                html += '</div></div></a></div></div>';
                html += '<div class="title"><a href="/products/' + product.url + '">' + YMMUtils.escapeHtml(product.product_name) + '</a></div>';
                html += '<div class="part-no">Part <span>#' + product.handle + '</span></div>';
                
                if (isLoggedIn) {
                    if (priceData.html) {
                        html += priceData.html;
                    }
                    html += '<div class="out-of-stock-label">Out of Stock</div>';
                    html += '<a href="/products/' + product.url + '" class="btn see-more-info">See more info</a>';
                }
                
                html += '</div></div>';
                return html;
            }
            
            var html = '<div class="grid-item">';
            html += '<div class="product-grid-item product-list-item out-of-stock-item line-' + uqId + '" attr-prod-id="' + product.product_id + '">';
            html += '<div class="grid">';
            html += '<div class="grid-item large--one-fifth medium--one-third">';
            html += '<div class="product-list-image">';
            html += '<a href="/products/' + product.url + searchString + '">';
            html += '<div class="lazyload__image-wrapper" style="padding-top:83.33333333333334%;">';
            html += this.catalogGridImageTag(image, options, '198px');
            html += '</div></a></div></div>';
            html += '<div class="grid-item large--three-fifths medium--two-thirds">';
            html += '<p class="h6"><a href="/products/' + product.url + searchString + '">' + YMMUtils.escapeHtml(product.product_name) + '</a></p>';
            html += '<div class="part-no">Part <span>#' + product.handle + '</span></div>';
            
            if (isLoggedIn) {
                if (priceData.html) {
                    html += priceData.html;
                }
                html += '<div class="product-actions product-list-template">';
                html += '<form method="post" action="/cart/add" id="addToCartForm-product-template" accept-charset="UTF-8" class="customize-content addToCartForm addToCartForm--payment-button" enctype="multipart/form-data" data-product-form="">';
                html += '<input type="hidden" name="form_type" value="product"><input type="hidden" name="utf8" value="✓">';
                html += '<select name="id" id="productSelect-product-template" data-select-uq="' + uqId + '" class="product-variants product-variants-product-template" style="display: none;">';
                html += '<option selected="selected" data-sku="' + (product.handle || '') + '" value="' + variantId + '">Default Title - $' + formattedPrice + ' USD</option>';
                html += '</select>';
                html += '<input type="hidden" value="1" name="quantity" id="" class="">';
                html += '<button type="button" class="btn add-to-cart out-of-stock">Out of Stock</button>';
                html += '<a href="/products/' + product.url + '" class="btn see-more-info">See more info <img src="//cdn.shopify.com/s/files/1/0454/6304/4257/t/2/assets/arrow-right.svg?v=13848028441984674738" alt="" title="" class="icon"></a>';
            }
            
            html += '<div class="buyers-guide"><a class="buyers-guide-link" href="javascript: void(0);" data-prod-id="' + product.product_id + '">Buyers Guide</a>';
            html += '<div class="buyers-guide-content" id="buyers_' + product.product_id + '">';
            html += '<h2>Buyers Guide: <span>' + YMMUtils.escapeHtml(product.product_name) + '</span><a href="javascript: void(0);" class="close"><img src="//cdn.shopify.com/s/files/1/0454/6304/4257/t/2/assets/close.svg?v=12198423699971312732" alt="" title=""></a></h2>';
            html += '<table class="scroll_compact"><thead><tr><th>Year</th><th>Make</th><th>Model</th><th>Engine</th></tr></thead><tbody><tr><td colspan="4" class="loading-spin"><img src="https://cdn.shopify.com/s/files/1/0281/6924/0651/t/12/assets/spinner.gif"></td></tr></tbody></table>';
            html += '</div></div>' + (priceData.propertiesHtml || '');
            
            if (isLoggedIn) {
                html += '</form></div>';
            }
            
            html += '</div>';
            html += '<div class="grid-item large--one-fifth medium--two-thirds">';
            html += '<div class="product-details">' + this.productMeta(product) + '</div>';
            html += '</div></div>';
            
            if (isLoggedIn) {
                html += '<div class="location_table" data-location-link="' + product.url + '" id="location_table_uq_' + uqId + '" data-location-uq="' + uqId + '" onclick="get_variant_location()"><main><details><summary onclick="get_location_availability(\'' + variantId + '\', this.getAttribute(\'class\'), this)" class="check_location_' + variantId + '" id="' + variantId + '"><h6>Check Availability <i class="location-icon material-icons">&#xe567;</i></h6></summary><div class="location_section location_section_' + variantId + '"><div class="location_loader"><img src="https://cdn.shopify.com/s/files/1/0281/6924/0651/t/12/assets/spinner.gif" height="30px" alt="location loader"></div></div></details></main></div>';
            }
            
            html += '</div></div>';
            
            return html;
        },
        
        pagination: function(currentPage, totalPages, baseParams) {
            currentPage = parseInt(currentPage) || 1;
            totalPages = parseInt(totalPages) || 1;
            
            if (totalPages <= 1) return '';
            
            var html = '';
            var params = new URLSearchParams();
            
            Object.keys(baseParams).forEach(function(key) {
                if (baseParams[key] && key !== 'p') {
                    params.set(key, baseParams[key]);
                }
            });
            
            if (currentPage > 1) {
                params.set('p', currentPage - 1);
                html += '<li><a href="/collections/catalog?' + params.toString() + '">Prev</a></li>';
            }
            
            var maxPages = 25;
            var start, end;
            
            if (totalPages > maxPages) {
                if (currentPage > 3 && currentPage < (totalPages - maxPages)) {
                    start = currentPage - 2;
                    end = currentPage + 2;
                } else if (currentPage >= (totalPages - maxPages)) {
                    start = totalPages - maxPages;
                    end = totalPages;
                } else {
                    start = 1;
                    end = maxPages;
                }
            } else {
                start = 1;
                end = totalPages;
            }
            
            for (var i = start; i <= end; i++) {
                params.set('p', i);
                if (i === currentPage) {
                    html += '<li class="button-primary"><span>' + i + '</span></li>';
                } else {
                    html += '<li class="button-primary"><a href="/collections/catalog?' + params.toString() + '">' + i + '</a></li>';
                }
            }
            
            if (currentPage < totalPages) {
                params.set('p', currentPage + 1);
                html += '<li class="button-primary"><a href="/collections/catalog?' + params.toString() + '">Next</a></li>';
            }
            
            return html;
        },
        
        noProducts: function() {
            return '<div class="no-products-found"><p>No products found matching your selection.</p></div>';
        },
        
        errorMessage: function() {
            return '<div class="products-error"><p>Unable to load products. Please try again.</p></div>';
        }
    };

    var YMMProductRenderer = {
        render: function(params) {
            var self = this;
            var $container = $(YMMConfig.selectors.productContainer);
            
            if (!$container.length) {
                $container = $('.collection-products');
            }
            
            YMMUtils.showLoader();
            
            var apiParams = {
                year: params.year,
                make: params.make,
                model: params.model,
                engine: params.engine,
                partType: params.partType,
                pageLimit: params.pageLimit || YMMConfig.defaults.pageLimit,
                pageNo: params.pageNo || YMMConfig.defaults.pageNo,
                customerId: YMMUtils.getCustomerId()
            };
            
            YMMAPI.getProducts(apiParams)
                .then(function(response) {
                    self.renderProducts(response, params);
                })
                .catch(function(error) {
                    console.error('[YMM] Failed to load products:', error);
                    $container.html(YMMTemplates.errorMessage());
                    
                    // Remove loading class to show pagination (prevents CLS)
                    $('.productgrid--outer').removeClass('catalog-page-loading');
                    
                    YMMUtils.hideLoader();
                });
        },
        
        renderProducts: function(response, params) {
            var $container = $(YMMConfig.selectors.productContainer);
            if (!$container.length) {
                $container = $('.collection-products');
            }
            
            var count = parseInt(response.count) || 0;
            var pageNo = parseInt(response.page_no) || 1;
            var totalPages = parseInt(response.total_pages) || 1;
            var products = response.products || [];
            
            if (YMMConfig.hideZeroPrice) {
                var initialLen = products.length;
                products = products.filter(function(product) {
                    var price = 0;
                    if (product.pricelist && typeof product.pricelist.final_price !== 'undefined' && product.pricelist.final_price !== null) {
                        price = parseFloat(product.pricelist.final_price);
                    } else if (product.price) {
                        price = parseFloat(product.price);
                    }
                    return !isNaN(price) && price > 0;
                });
                
                var removedCount = initialLen - products.length;
                if (removedCount > 0) {
                    count = Math.max(0, count - removedCount);
                }
            }
            
            if (YMMConfig.hideOos) {
                var initialLenOos = products.length;
                products = products.filter(function(product) {
                    var inStock = parseInt(product.in_stock);
                    var qty = parseInt(product.quantity);
                    return (!isNaN(inStock) && inStock > 0) || (!isNaN(qty) && qty > 0);
                });
                
                var removedCountOos = initialLenOos - products.length;
                if (removedCountOos > 0) {
                    count = Math.max(0, count - removedCountOos);
                }
            }
            
            if (!products.length) {
                $container.html(YMMTemplates.noProducts());
                $(YMMConfig.selectors.pagination).html('');
                $(YMMConfig.selectors.paginateInfo).html('0 items');
                
                // Remove loading class to show pagination (prevents CLS)
                $('.productgrid--outer').removeClass('catalog-page-loading');
                
                YMMUtils.hideLoader();
                return;
            }
            
            var isLoggedIn = YMMUtils.isLoggedIn();
            var viewMode = params.viewMode || YMMUtils.getCurrentViewMode();
            var searchString = this.buildSearchString(params);
            var uqCount = Math.floor(Math.random() * 50000);
            var html = '';
            
            for (var i = 0; i < products.length; i++) {
                uqCount++;
                var product = products[i];
                
                window.ymm_items[product.product_id] = product;
                
                var options = {
                    isLoggedIn: isLoggedIn,
                    uqId: uqCount,
                    searchString: searchString,
                    viewMode: viewMode,
                    isFirstProduct: i === 0
                };
                
                if (product.in_stock < 1) {
                    html += YMMTemplates.productOutOfStock(product, options);
                } else if (viewMode === 'grid-view') {
                    html += YMMTemplates.productGridItem(product, options);
                } else {
                    html += YMMTemplates.productListItem(product, options);
                }
            }
            
            $container.html(html);
            
            if (typeof window.catalogImageFallback === 'function') {
                setTimeout(function() {
                    window.catalogImageFallback();
                }, 250);
            }
            
            if (typeof window.catalogBundleGraphQL !== 'undefined' && typeof window.catalogBundleManager !== 'undefined') {
                var productIds = [];
                $(".productgrid--items [attr-prod-id]").each(function() {
                    var prodId = $(this).attr("attr-prod-id");
                    if (prodId && productIds.indexOf(prodId) === -1) {
                        productIds.push(prodId);
                    }
                });
                
                if (productIds.length > 0) {
                    var productsForBundle = productIds.map(function(id) {
                        return { product_id: id };
                    });
                    
                    window.catalogBundleGraphQL.fetchBundlesForProducts(productsForBundle).then(function() {
                        var containerEl = document.querySelector(".productgrid--items");
                        if (containerEl) {
                            window.catalogBundleManager.initializeCatalogProducts(containerEl);
                        }
                    }).catch(function(error) {
                        console.error('Error initializing catalog bundles:', error);
                    });
                }
            }
            
            var paginationParams = {
                ymm_year: params.year,
                ymm_make: params.make,
                ymm_model: params.model,
                ymm_engine: params.engine,
                ymm_part_type: params.partType,
                grid_list: viewMode
            };
            
            var paginationHtml = YMMTemplates.pagination(pageNo, totalPages, paginationParams);
            $(YMMConfig.selectors.pagination).html(paginationHtml);
            
            var currentPageLimit = params.pageLimit || YMMConfig.defaults.pageLimit;
            this.updatePaginateInfo(count, currentPageLimit, pageNo);
            
            // Update the pagination UI with dynamic options based on total count
            this.updatePaginationUI(currentPageLimit, count);
            
            // Remove loading class to show pagination (prevents CLS)
            $('.productgrid--outer').removeClass('catalog-page-loading');
            
            YMMUtils.hideLoader();
        },
        
        buildSearchString: function(params) {
            var parts = [];
            if (params.year) parts.push('ymm_year=' + encodeURIComponent(params.year));
            if (params.make) parts.push('ymm_make=' + encodeURIComponent(params.make));
            if (params.model) parts.push('ymm_model=' + encodeURIComponent(params.model));
            if (params.engine) parts.push('ymm_engine=' + encodeURIComponent(params.engine));
            if (params.partType) parts.push('ymm_part_type=' + encodeURIComponent(params.partType));
            return parts.length ? '?' + parts.join('&') : '';
        },
        
        updatePaginateInfo: function(total, pageLimit, pageNo) {
            var text;
            var start = ((pageNo - 1) * pageLimit) + 1;
            var end = Math.min(pageNo * pageLimit, total);
            
            if (total === 0) {
                text = '0 items';
            } else if (total === 1) {
                text = '1 item';
            } else if (total <= pageLimit) {
                text = total + ' items';
            } else {
                text = start + '-' + end + ' of ' + total;
            }
            
            $(YMMConfig.selectors.paginateInfo).html(text);
        },
        
        updatePaginationUI: function(pageLimit, totalCount) {
            var $showByContainer = $('.utils-showby');
            if (!$showByContainer.length) {
                return;
            }
            
            // If totalCount is not provided, just update active states
            if (typeof totalCount === 'undefined') {
                $('.utils-showby-item').each(function() {
                    var $item = $(this);
                    var itemPageLimit = parseInt($item.attr('attr-page'));
                    
                    if (itemPageLimit === pageLimit) {
                        $item.addClass('utils-showby-item--active');
                    } else {
                        $item.removeClass('utils-showby-item--active');
                    }
                });
                return;
            }
            
            // Calculate which pagination options to show based on total count
            var availableOptions = [];
            var firstOption = YMMConfig.paginationOptions[0]; // Usually 25
            
            // If total count is less than the first option (25), show the actual count instead
            if (totalCount > 0 && totalCount < firstOption) {
                availableOptions.push(totalCount);
            } else {
                // Normal behavior: show options based on total count
                for (var i = 0; i < YMMConfig.paginationOptions.length; i++) {
                    var option = YMMConfig.paginationOptions[i];
                    // Show option if it's less than or equal to total count
                    if (option <= totalCount) {
                        availableOptions.push(option);
                    }
                }
                
                // If total count is greater than the last shown option, add the next option
                if (availableOptions.length > 0) {
                    var lastOption = availableOptions[availableOptions.length - 1];
                    var lastOptionIndex = YMMConfig.paginationOptions.indexOf(lastOption);
                    
                    if (totalCount > lastOption && lastOptionIndex < YMMConfig.paginationOptions.length - 1) {
                        availableOptions.push(YMMConfig.paginationOptions[lastOptionIndex + 1]);
                    }
                }
            }
            
            // Get current URL parameters for building links
            var currentUrl = window.location.href;
            var urlObj = new URL(currentUrl);
            var searchParams = new URLSearchParams(urlObj.search);
            
            // Preserve YMM parameters
            var ymmParams = [];
            if (searchParams.get('ymm_year')) ymmParams.push('ymm_year=' + encodeURIComponent(searchParams.get('ymm_year')));
            if (searchParams.get('ymm_make')) ymmParams.push('ymm_make=' + encodeURIComponent(searchParams.get('ymm_make')));
            if (searchParams.get('ymm_model')) ymmParams.push('ymm_model=' + encodeURIComponent(searchParams.get('ymm_model')));
            if (searchParams.get('ymm_engine')) ymmParams.push('ymm_engine=' + encodeURIComponent(searchParams.get('ymm_engine')));
            if (searchParams.get('ymm_part_type')) ymmParams.push('ymm_part_type=' + encodeURIComponent(searchParams.get('ymm_part_type')));
            if (searchParams.get('id')) ymmParams.push('id=' + encodeURIComponent(searchParams.get('id')));
            
            var baseUrl = urlObj.origin + urlObj.pathname;
            var ymmParamString = ymmParams.length > 0 ? ymmParams.join('&') : '';
            
            // Rebuild the pagination HTML
            var html = '<li><span class="utils-showby-title">Show</span></li>';
            
            for (var j = 0; j < availableOptions.length; j++) {
                var option = availableOptions[j];
                // Determine active state:
                // 1. If option matches current pageLimit, it's active
                // 2. If showing actual count (< 25), make it active (since it represents all available products)
                var isActive = (option === pageLimit) || 
                               (totalCount < firstOption && option === totalCount);
                var activeClass = isActive ? 'utils-showby-item--active' : '';
                
                var href = baseUrl + '?' + ymmParamString + '&product_limit=' + option + '&grid_list=list-view';
                
                html += '<li>' +
                    '<a class="button-primary utils-showby-item ' + activeClass + '" ' +
                    'href="' + href + '" ' +
                    'aria-label="show ' + option + ' items" ' +
                    'attr-page="' + option + '">' +
                    option +
                    '</a>' +
                    '</li>';
            }
            
            $showByContainer.html(html);
        }
    };

    var YMMCart = {
        addToCart: function($form, callback) {
            var formData = $form.serialize();
            var $button = $form.find('.add-to-cart');
            var originalText = $button.html();
            
            $button.prop('disabled', true).html('<span>Adding...</span>');
            
            $.ajax({
                url: '/cart/add.js',
                type: 'POST',
                data: formData,
                dataType: 'json',
                success: function(item) {
                    $button.html('<span>Added!</span>');
                    setTimeout(function() {
                        $button.prop('disabled', false).html(originalText);
                    }, 2000);
                    
                    YMMCart.updateCartCount();
                    
                    if (typeof callback === 'function') {
                        callback(null, item);
                    }
                },
                error: function(xhr) {
                    var errorMessage = 'Error adding to cart';
                    try {
                        var response = JSON.parse(xhr.responseText);
                        errorMessage = response.description || response.message || errorMessage;
                    } catch (e) {}
                    
                    $button.html('<span>' + errorMessage + '</span>');
                    setTimeout(function() {
                        $button.prop('disabled', false).html(originalText);
                    }, 3000);
                    
                    if (typeof callback === 'function') {
                        callback(errorMessage, null);
                    }
                }
            });
        },
        
        updateCartCount: function() {
            $.getJSON('/cart.js', function(cart) {
                var count = cart.item_count;
                $('.cart-link--count, .cart-count').text(count);
                if (count > 0) {
                    $('.cart-link--count, .cart-count').removeClass('hidden');
                }
            });
        },
        
        adjustQuantity: function($adjuster) {
            var $input = $adjuster.siblings('input[name="quantity"]');
            var currentQty = parseInt($input.val()) || 1;
            var newQty;
            
            if ($adjuster.hasClass('catalog--js--minus')) {
                newQty = Math.max(1, currentQty - 1);
            } else {
                newQty = currentQty + 1;
            }
            
            $input.val(newQty);
            $adjuster.filter('.catalog--js--minus').attr('data-qty', newQty - 1);
            $adjuster.filter('.catalog--js--add').attr('data-qty', newQty + 1);
        }
    };

    var YMMBuyersGuide = {
        cache: {},
        
        show: function(productId) {
            var $content = $('#buyers_' + productId);
            $content.addClass('active').show();
            
            if (!this.cache[productId]) {
                this.loadData(productId);
            }
        },
        
        hide: function(productId) {
            var $content = $('#buyers_' + productId);
            $content.removeClass('active').hide();
        },
        
        loadData: function(productId) {
            var self = this;
            var $tbody = $('#buyers_' + productId + ' tbody');
            
            YMMAPI.fetch({
                type: 'ajax',
                request: 'compatibility',
                product: productId,
                page: 1,
                limit: 10,
                format: 'json'
            }).then(function(data) {
                self.cache[productId] = data;
                self.renderTable(productId, data);
            }).catch(function() {
                $tbody.html('<tr><td colspan="4">Failed to load data</td></tr>');
            });
        },
        
        renderTable: function(productId, data) {
            var $tbody = $('#buyers_' + productId + ' tbody');
            
            if (!data || !data.length) {
                $tbody.html('<tr><td colspan="4">No application data found</td></tr>');
                return;
            }
            
            var html = '';
            for (var i = 0; i < data.length; i++) {
                var app = data[i];
                html += '<tr>';
                html += '<td>' + (app.value_name4 || app.year || '-') + '</td>';
                html += '<td>' + (app.value_name3 || app.make || '-') + '</td>';
                html += '<td>' + (app.value_name2 || app.model || '-') + '</td>';
                html += '<td>' + (app.value_name1 || app.engine || '-') + '</td>';
                html += '</tr>';
            }
            
            $tbody.html(html);
        }
    };

    var YMMRecentSearches = {
        render: function() {
            var searches = YMMUtils.getRecentSearches();
            if (!searches.length) {
                $('.year-make-model-search .ymm-foot').removeClass('active');
                return;
            }
            
            var html = "<span class='recent_label'><b>Recent Searches</b></span><ul class='recent_searches' style='visibility: hidden;opacity: 0;'>";
            for (var i = 0; i < searches.length; i++) {
                var url = searches[i];
                var paramString = url.split('?')[1];
                if (!paramString) continue;
                
                var queryString = new URLSearchParams(paramString);
                var linkText = '';
                
                for (var pair of queryString.entries()) {
                    if (pair[0] !== 'id' && pair[0] !== 'grid_list' && pair[0] !== 'p') {
                        linkText += pair[1] + ' ';
                    }
                }
                
                linkText = linkText.trim();
                html += "<li><a href='" + url + "'>" + linkText + "</a></li>";
            }
            html += '</ul>';
            
            $('.year-make-model-search .ymm-foot').html(html).addClass('active');
        },
        
        bindHoverEvents: function() {
            $(document).on('mouseenter', '.recent_label, .ymm-foot ul', function() {
                var $recentSearches = document.querySelector('.recent_searches');
                if ($recentSearches) {
                    $recentSearches.style.visibility = 'visible';
                    $recentSearches.style.opacity = '1';
                }
            });
            
            $(document).on('mouseleave', '.ymm-foot ul, .recent_label', function() {
                var $recentSearches = document.querySelector('.recent_searches');
                if ($recentSearches) {
                    $recentSearches.style.visibility = 'hidden';
                    $recentSearches.style.opacity = '0';
                }
            });
        }
    };

    var YMMViewToggle = {
        currentMode: 'list-view',
        
        initialize: function() {
            this.currentMode = YMMUtils.getCurrentViewMode();
            this.updateUI();
        },
        
        toggle: function(mode) {
            if (mode === this.currentMode) return;
            
            this.currentMode = mode;
            this.updateUI();
            this.updateUrl();
            
            if (YMMUtils.hasYMMParams()) {
                var params = YMMUtils.getYMMParams();
                params.viewMode = mode;
                YMMProductRenderer.render(params);
            }
        },
        
        updateUI: function() {
            var $buttons = $(YMMConfig.selectors.viewToggle);
            $buttons.removeClass('active');
            $buttons.filter('[data-collection-view="' + this.currentMode + '"]').addClass('active');
            
            var $container = $(YMMConfig.selectors.productContainer);
            if (this.currentMode === 'grid-view') {
                $container.removeClass('productgrid--list').addClass('productgrid--grid');
            } else {
                $container.removeClass('productgrid--grid').addClass('productgrid--list');
            }
        },
        
        updateUrl: function() {
            var url = new URL(window.location.href);
            url.searchParams.set('grid_list', this.currentMode);
            window.history.replaceState({}, '', url.toString());
        }
    };

    var YMMEvents = {
        bindAll: function() {
            this.bindDropdownEvents();
            this.bindCartEvents();
            this.bindBuyersGuideEvents();
            this.bindViewToggleEvents();
            this.bindVariantSelectEvents();
            this.bindMobileMenuEvents();
            this.bindKeyboardEvents();
            this.bindSlickSliderEvents();
            this.bindRecentSearchesEvents();
            this.bindPaginationEvents();
        },
        
        bindSlickSliderEvents: function() {
            $(document).on('click', '.slick-dots li button', function() {
                var curPos = parseInt($(this).text());
                var curImage = $('body .large--one-quarter.slick-slide').eq(curPos).find('a').attr('href');
                $('body #productPhotoContainer-product-template .product__image-wrapper img')
                    .attr('src', curImage)
                    .attr('srcset', curImage);
            });
        },
        
        bindDropdownEvents: function() {
            YMMDropdown.bindEvents();
        },
        
        bindCartEvents: function() {
            $(document).on('click', '.catalog--qty-adjuster', function(e) {
                e.preventDefault();
                YMMCart.adjustQuantity($(this));
            });
            
            $(document).on('click', '.add-to-cart:not(.out-of-stock):not(.out-of-stock-btn):not(.bundle-product)', function(e) {
                e.preventDefault();

                // Skip add to cart, if empire.js already handled this click to avoid duplicate add-to-cart
                if ($(this).data('atc-handled')) {
                    $(this).removeData('atc-handled');
                    return;
                }

                var $form = $(this).closest('form');
                
                if ($form.find('.product-variants').val() === '' || $form.find('.product-variants').val() === null) {
                    alert('Please select a size option');
                    return;
                }
                
                YMMCart.addToCart($form);
            });
            
            $(document).on('keypress', 'input[name="quantity"]', function(e) {
                if (!/[0-9]/.test(String.fromCharCode(e.which))) {
                    e.preventDefault();
                }
            });
        },
        
        bindBuyersGuideEvents: function() {
            $(document).on('click', '.buyers-guide-link', function(e) {
                e.preventDefault();
                var productId = $(this).data('prod-id');
                YMMBuyersGuide.show(productId);
            });
            
            $(document).on('click', '.buyers-guide-content .close', function(e) {
                e.preventDefault();
                var $content = $(this).closest('.buyers-guide-content');
                var productId = $content.attr('id').replace('buyers_', '');
                YMMBuyersGuide.hide(productId);
            });
            
            $(document).on('click', function(e) {
                if (!$(e.target).closest('.buyers-guide').length) {
                    $('.buyers-guide-content.active').removeClass('active').hide();
                }
            });
        },
        
        bindViewToggleEvents: function() {
            $(document).on('click', YMMConfig.selectors.viewToggle, function(e) {
                e.preventDefault();
                var mode = $(this).data('collection-view');
                YMMViewToggle.toggle(mode);
            });
        },
        
        bindVariantSelectEvents: function() {
            $(document).on('change', '.product_varient_select', function() {
                var $select = $(this);
                
                if ($select.closest('.item.divRow').length > 0) {
                    return;
                }
                
                var uqId = $select.data('uq');
                var selectedValue = $select.val();
                var selectedSku = $select.find('option:selected').data('sku');
                var productId = $select.attr('product_id');
                var $parentContainer = $select.closest('.product-grid-item');
                
                var $hiddenSelect = $('[data-select-uq="' + uqId + '"]');
                $hiddenSelect.val(selectedValue);
                
                var $locationSummary = $select.closest('.product-grid-item, .product-list-item').find('.location_table summary');
                if ($locationSummary.length && selectedValue) {
                    $locationSummary.attr('id', selectedValue);
                    $locationSummary.attr('class', 'check_location_' + selectedValue);
                    $locationSummary.attr('onclick', 'get_location_availability(' + selectedValue + ', this.getAttribute("class"), this)');
                }
                
                var customerId = '';
                if (typeof meta !== 'undefined' && typeof meta.page !== 'undefined' && typeof meta.page.customerId !== 'undefined') {
                    customerId = meta.page.customerId;
                }
                
                if (!customerId || !productId || !selectedSku) return;
                
                $('.bundle-loader').css('display', 'block');
                
                var variantPrice = 0;
                if (typeof window.ymm_items !== 'undefined' && typeof window.ymm_items[productId] !== 'undefined') {
                    var productData = window.ymm_items[productId];
                    var currentVariants = productData.varient_list || [];
                    
                    for (var i = 0; i < currentVariants.length; i++) {
                        if (currentVariants[i].varient_id == selectedValue) {
                            variantPrice = parseFloat(currentVariants[i].sale_price || 0);
                            break;
                        }
                    }
                    
                    if (variantPrice === 0 && productData.price) {
                        variantPrice = parseFloat(productData.price);
                    }
                }
                
                YMMAPI.fetch({
                    type: 'ajax',
                    action: 'getprice',
                    product_id: productId,
                    customer_id: customerId,
                    sku: selectedSku
                }).then(function(data) {
                    if (!data || data === '') return;
                    
                    var propertiesHtml = '';
                    var price = variantPrice;
                    
                    if (data.discount_type === 'fixed') {
                        var jobberHtml = 'Jobber Price : $' + price.toFixed(2);
                        $parentContainer.find('.product-item--price small[aria-hidden="true"]').html(jobberHtml);
                        
                        if ($parentContainer.find('.price__customcurrent').length > 0) {
                            $parentContainer.find('.price__customcurrent span.money').html(' $' + parseFloat(data.discount_value).toFixed(2));
                        } else {
                            var customPriceHtml = '<div class="price__customcurrent" data-customprice-container><span class="money-label" data-price-label>Your Price :</span><span class="money" data-price=""> $' + parseFloat(data.discount_value).toFixed(2) + '</span></div>';
                            $parentContainer.find('.product-item--price').after(customPriceHtml);
                        }
                        
                        if ($parentContainer.find('input[name="properties[_discountPrice]"]').length >= 1) {
                            $parentContainer.find('input[name="properties[_discountPrice]"]').val(parseFloat(data.discount_value).toFixed(2));
                        } else {
                            propertiesHtml += '<input type="hidden" name="properties[_discountPrice]" data-property-name="_discountPrice" value="' + parseFloat(data.discount_value).toFixed(2) + '">';
                        }
                        if ($parentContainer.find('input[name="properties[_discountType]"]').length >= 1) {
                            $parentContainer.find('input[name="properties[_discountType]"]').val(data.discount_type);
                        } else {
                            propertiesHtml += '<input type="hidden" name="properties[_discountType]" data-property-name="_discountType" value="' + data.discount_type + '">';
                        }
                        if ($parentContainer.find('input[name="properties[_discountValue]"]').length >= 1) {
                            $parentContainer.find('input[name="properties[_discountValue]"]').val(data.discount_value);
                        } else {
                            propertiesHtml += '<input type="hidden" name="properties[_discountValue]" data-property-name="_discountValue" value="' + data.discount_value + '">';
                        }
                        $parentContainer.find('input[name="properties[_discountTag]"]').remove();
                        $parentContainer.find('form[data-product-form]').append(propertiesHtml);
                        
                    } else if (data.discount_type === 'percentage') {
                        var jobberHtml = 'Jobber Price : $' + price.toFixed(2);
                        $parentContainer.find('.product-item--price small[aria-hidden="true"]').html(jobberHtml);
                        
                        var priceDiscount = price - (price * parseFloat(data.discount_value) / 100);
                        
                        if ($parentContainer.find('.price__customcurrent').length > 0) {
                            $parentContainer.find('.price__customcurrent span.money').html(' $' + priceDiscount.toFixed(2));
                        } else {
                            var customPriceHtml = '<div class="price__customcurrent" data-customprice-container><span class="money-label" data-price-label>Your Price :</span><span class="money" data-price=""> $' + priceDiscount.toFixed(2) + '</span></div>';
                            $parentContainer.find('.product-item--price').after(customPriceHtml);
                        }
                        
                        if ($parentContainer.find('input[name="properties[_discountPrice]"]').length >= 1) {
                            $parentContainer.find('input[name="properties[_discountPrice]"]').val(priceDiscount.toFixed(2));
                        } else {
                            propertiesHtml += '<input type="hidden" name="properties[_discountPrice]" data-property-name="_discountPrice" value="' + priceDiscount.toFixed(2) + '">';
                        }
                        if ($parentContainer.find('input[name="properties[_discountType]"]').length >= 1) {
                            $parentContainer.find('input[name="properties[_discountType]"]').val(data.discount_type);
                        } else {
                            propertiesHtml += '<input type="hidden" name="properties[_discountType]" data-property-name="_discountType" value="' + data.discount_type + '">';
                        }
                        if ($parentContainer.find('input[name="properties[_discountValue]"]').length >= 1) {
                            $parentContainer.find('input[name="properties[_discountValue]"]').val(data.discount_value);
                        } else {
                            propertiesHtml += '<input type="hidden" name="properties[_discountValue]" data-property-name="_discountValue" value="' + data.discount_value + '">';
                        }
                        if (data.tag) {
                            propertiesHtml += '<input type="hidden" name="properties[_discountTag]" data-property-name="_discountTag" value="' + data.tag + '">';
                        }
                        $parentContainer.find('form[data-product-form]').append(propertiesHtml);
                    }
                    
                    $('.bundle-loader').css('display', 'none');
                }).catch(function(error) {
                    console.error('Failed to fetch variant pricing:', error);
                    $('.bundle-loader').css('display', 'none');
                });
            });
        },
        
        bindMobileMenuEvents: function() {
            $(document).on('click', '.mobile-header', function() {
                $('.ymm-form').slideToggle('slow');
            });
        },
        
        bindKeyboardEvents: function() {
            $(document).on('keydown', function(e) {
                if (e.key === 'Escape') {
                    $('.buyers-guide-content.active').removeClass('active').hide();
                }
            });
        },
        
        bindRecentSearchesEvents: function() {
            YMMRecentSearches.bindHoverEvents();
        },
        
        bindPaginationEvents: function() {
            // Intercept pagination link clicks
            $(document).on('click', '.utils-showby-item', function(e) {
                e.preventDefault();
                
                var $link = $(this);
                var pageLimit = parseInt($link.attr('attr-page')) || YMMConfig.defaults.pageLimit;
                
                // Check if we're on catalog page with YMM params
                if (YMMUtils.isCatalogPage() && YMMUtils.hasYMMParams()) {
                    // Get current YMM params
                    var params = YMMUtils.getYMMParams();
                    params.pageLimit = pageLimit;
                    params.pageNo = 1; // Reset to first page when changing page limit
                    
                    // Update URL with new page limit
                    var url = new URL(window.location.href);
                    url.searchParams.set('product_limit', pageLimit);
                    url.searchParams.set('p', 1);
                    window.history.replaceState({}, '', url.toString());
                    
                    // Re-render products with new page limit
                    YMMProductRenderer.render(params);
                    
                    // Update active state
                    $('.utils-showby-item').removeClass('utils-showby-item--active');
                    $link.addClass('utils-showby-item--active');
                } else {
                    // If no YMM params, follow the default link
                    window.location.href = $link.attr('href');
                }
            });
        }
    };

    var YMMApp = {
        initialized: false,
        
        init: function() {
            if (this.initialized) return;
            
            var self = this;
            
            $(document).ready(function() {
                self.start();
            });
        },
        
        start: function() {
            if (this.initialized) return;
            this.initialized = true;
            
            YMMEvents.bindAll();
            
            this.initLoginPage();
            this.initProductPageSkuHiding();
            
            if (YMMUtils.isHomePage()) {
                this.initHomePage();
            } else if (YMMUtils.isCatalogPage()) {
                this.initCatalogPage();
            } else if (YMMUtils.isProductPage()) {
                this.initProductPage();
            } else if (YMMUtils.isCollectionPage() || YMMUtils.isSearchPage()) {
                this.initCollectionPage();
            }
            
            YMMRecentSearches.render();
            YMMViewToggle.initialize();
        },
        
        initLoginPage: function() {
            if (!$('body').hasClass('template-login')) return;
            
            var checkoutUrl = YMMUtils.getUrlParam('checkout_url');
            if (checkoutUrl) {
                $('form#customer_login').append('<input type="hidden" name="checkout_url" value="/cart">');
            }
        },
        
        initProductPageSkuHiding: function() {
            if (!YMMUtils.isProductPage()) return;
            
            var customSkuPrefixes = ['HGB', 'LFK', 'FGK', 'VK', 'P', 'PR', 'MB', 'RB'];
            var skuCode = $('.part_no_sku').val() || '';
            var skuPrefix = skuCode.split(/[0-9]/)[0].toUpperCase();
            
            if (customSkuPrefixes.indexOf(skuPrefix) >= 0) {
                if ($('.customize-header').length > 0) {
                    $('.customize-header').addClass('hide-title');
                }
                if ($('.product-features').length > 0) {
                    $('.product-features').addClass('hide-features');
                }
                if ($('.customize-right').length > 0) {
                    $('.customize-right').addClass('update-right-section');
                }
            }
        },
        
        initHomePage: function() {
            YMMDropdown.initialize();
        },
        
        initCollectionPage: function() {
            this.loadCollectionPricing();
            this.loadRecentlyViewedPricing();
            this.initCollectionBundles();
        },
        
        initCollectionBundles: function() {
            if (typeof window.collectionBundleManager !== 'undefined') {
                var container = document.querySelector('#collection-alternative') || 
                               document.querySelector('.productgrid--items') ||
                               document.querySelector('.productgrid--wrapper');
                if (container) {
                    window.collectionBundleManager.initializeCollectionProducts(container, 'collection');
                }
            }
        },
        
        hasMetaobjectBundle: function(productId) {
            if (window.catalogBundleData && window.catalogBundleData[productId]) {
                return 'catalog';
            }
            if (window.collectionBundleData && window.collectionBundleData[productId]) {
                return 'collection';
            }
            if (window.bundleMetaobjectData && window.bundleMetaobjectData[productId]) {
                return 'product';
            }
            return null;
        },
        
        loadCollectionPricing: function() {
            var customerId = YMMUtils.getCustomerId();
            if (!customerId) return;
            
            $('.productgrid--item').each(function() {
                var $item = $(this);
                var productId = $item.attr('attr-prod-id');
                var productSku = $item.attr('attr-prod-sku');
                
                if (!productId) return;
                
                if (productSku) {
                    productSku = productSku.replace('_config', '');
                }
                
                var priceAttr = $item.find('.money[data-price]').attr('attr-price');
                var price = parseFloat(YMMCompat.formatWithDelimiters(priceAttr, 2).replace(/,/g, '')) || 0;
                
                YMMAPI.fetch({
                    type: 'ajax',
                    action: 'getprice',
                    product_id: productId,
                    customer_id: customerId,
                    sku: productSku
                }).then(function(data) {
                    if (!data || data === '') return;
                    
                    var propertiesHtml = '';
                    
                    if (data.discount_type === 'fixed') {
                        $item.find('.money-label[data-price-label]').css('display', 'inline-block');
                        var customPriceHtml = '<div class="price__customcurrent" data-customprice-container><span class="money-label" data-price-label style="display: inline-block;">Your Price :</span><span class="money" data-price=""> $' + parseFloat(data.discount_value).toFixed(2) + '</span></div>';
                        $item.find('.price__current[data-price-container]').after(customPriceHtml);
                        
                        propertiesHtml += '<input type="hidden" name="properties[_discountPrice]" data-property-name="_discountPrice" value="' + parseFloat(data.discount_value).toFixed(2) + '">';
                        propertiesHtml += '<input type="hidden" name="properties[_discountType]" data-property-name="_discountType" value="' + data.discount_type + '">';
                        propertiesHtml += '<input type="hidden" name="properties[_discountValue]" data-property-name="_discountValue" value="' + data.discount_value + '">';
                        $item.find('form[data-product-form]').append(propertiesHtml);
                        
                    } else if (data.discount_type === 'percentage') {
                        var priceDiscount = price - (price * parseFloat(data.discount_value) / 100);
                        
                        $item.find('.money-label[data-price-label]').css('display', 'inline-block');
                        var customPriceHtml = '<div class="price__customcurrent" data-customprice-container><span class="money-label" data-price-label style="display: inline-block;">Your Price :</span><span class="money" data-price=""> $' + priceDiscount.toFixed(2) + '</span></div>';
                        $item.find('.price__current[data-price-container]').after(customPriceHtml);
                        
                        propertiesHtml += '<input type="hidden" name="properties[_discountPrice]" data-property-name="_discountPrice" value="' + priceDiscount.toFixed(2) + '">';
                        propertiesHtml += '<input type="hidden" name="properties[_discountType]" data-property-name="_discountType" value="' + data.discount_type + '">';
                        propertiesHtml += '<input type="hidden" name="properties[_discountValue]" data-property-name="_discountValue" value="' + data.discount_value + '">';
                        if (data.tag) {
                            propertiesHtml += '<input type="hidden" name="properties[_discountTag]" data-property-name="_discountTag" value="' + data.tag + '">';
                        }
                        $item.find('form[data-product-form]').append(propertiesHtml);
                    }
                    
                    if (!$('.product-form--atc-button').hasClass('disabled')) {
                        $('.product-form--atc-button').attr('disabled', false);
                    }
                    if (!$item.find('.productitem--action-atc').hasClass('disabled')) {
                        $item.find('.productitem--action-atc').attr('disabled', false);
                    }
                }).catch(function(error) {
                    console.error('Failed to load collection pricing for product:', productId, error);
                });
            });
        },
        
        loadRecentlyViewedPricing: function() {
            var self = this;
            var checkCustom = 0;
            var myInterval = setInterval(function() {
                if ($('.recently-viewed--section').length > 0) {
                    checkCustom = 1;
                }
                if (checkCustom === 1) {
                    self.loadPricelistForSection('recently-viewed--section');
                    clearInterval(myInterval);
                }
            }, 1000);
        },
        
        loadPricelistForSection: function(parentClass) {
            var customerId = YMMUtils.getCustomerId();
            if (!customerId) return;
            
            $('.' + parentClass + ' .productgrid--item').each(function() {
                var $item = $(this);
                var productId = $item.attr('attr-prod-id');
                var productSku = $item.attr('attr-prod-sku');
                
                if (!productId) return;
                
                if (productSku) {
                    productSku = productSku.replace('_config', '');
                }
                
                var priceAttr = $item.find('.money[data-price]').attr('attr-price');
                var price = parseFloat(YMMCompat.formatWithDelimiters(priceAttr, 2)) || 0;
                
                YMMAPI.fetch({
                    type: 'ajax',
                    action: 'getprice',
                    product_id: productId,
                    customer_id: customerId,
                    sku: productSku
                }).then(function(data) {
                    if (!data || data === '') return;
                    
                    var propertiesHtml = '';
                    
                    if (data.discount_type === 'fixed') {
                        $item.find('.money-label[data-price-label]').css('display', 'inline-block');
                        var customPriceHtml = '<div class="price__customcurrent" data-customprice-container><span class="money-label" data-price-label style="display: inline-block;">Your Price :</span><span class="money" data-price=""> $' + parseFloat(data.discount_value).toFixed(2) + '</span></div>';
                        $item.find('.price__current[data-price-container]').after(customPriceHtml);
                        
                        propertiesHtml += '<input type="hidden" name="properties[_discountPrice]" data-property-name="_discountPrice" value="' + parseFloat(data.discount_value).toFixed(2) + '">';
                        propertiesHtml += '<input type="hidden" name="properties[_discountType]" data-property-name="_discountType" value="' + data.discount_type + '">';
                        propertiesHtml += '<input type="hidden" name="properties[_discountValue]" data-property-name="_discountValue" value="' + data.discount_value + '">';
                        $item.find('form[data-product-form]').append(propertiesHtml);
                        
                    } else if (data.discount_type === 'percentage') {
                        var priceDiscount = price - (price * parseFloat(data.discount_value) / 100);
                        
                        $item.find('.money-label[data-price-label]').css('display', 'inline-block');
                        var customPriceHtml = '<div class="price__customcurrent" data-customprice-container><span class="money-label" data-price-label style="display: inline-block;">Your Price :</span><span class="money" data-price=""> $' + priceDiscount.toFixed(2) + '</span></div>';
                        $item.find('.price__current[data-price-container]').after(customPriceHtml);
                        
                        propertiesHtml += '<input type="hidden" name="properties[_discountPrice]" data-property-name="_discountPrice" value="' + priceDiscount.toFixed(2) + '">';
                        propertiesHtml += '<input type="hidden" name="properties[_discountType]" data-property-name="_discountType" value="' + data.discount_type + '">';
                        propertiesHtml += '<input type="hidden" name="properties[_discountValue]" data-property-name="_discountValue" value="' + data.discount_value + '">';
                        if (data.tag) {
                            propertiesHtml += '<input type="hidden" name="properties[_discountTag]" data-property-name="_discountTag" value="' + data.tag + '">';
                        }
                        $item.find('form[data-product-form]').append(propertiesHtml);
                    }
                    
                    if (!$('.product-form--atc-button').hasClass('disabled')) {
                        $('.product-form--atc-button').attr('disabled', false);
                    }
                    if (!$item.find('.productitem--action-atc').hasClass('disabled')) {
                        $item.find('.productitem--action-atc').attr('disabled', false);
                    }
                }).catch(function(error) {
                    console.error('Failed to load pricing for section:', parentClass, error);
                });
            });
        },
        
        applicationDataLoaded: false,
        
        initProductPage: function() {
            var self = this;
            
            this.loadCompatibilityData();
            this.loadProductPricing();
            this.loadApplicationData();
            this.loadRecentlyViewedPricing();
            this.loadProductRecommendationsPricing();
            
            $('select[data-variants]').on('change', function() {
                self.loadProductPricing();
                self.loadApplicationData(true);
            });
        },
        
        loadProductRecommendationsPricing: function() {
            var self = this;
            var checkCustom = 0;
            var myInterval = setInterval(function() {
                if ($('.product-recommendations--section').length > 0) {
                    checkCustom = 1;
                }
                if (checkCustom === 1) {
                    self.loadPricelistForSection('product-recommendations--section');
                    clearInterval(myInterval);
                }
            }, 1000);
        },
        
        loadApplicationData: function(isVariantChange) {
            var self = this;
            var referrer = document.referrer;
            if (!referrer) return;
            
            if (!isVariantChange && this.applicationDataLoaded) return;
            this.applicationDataLoaded = true;
            
            var refArr = referrer.split('/');
            var locArr = window.location.href.split('/');
            
            if (refArr[3] === 'collections' && locArr[3] === 'products' && refArr[4] && refArr[4].split('?')[1]) {
                var modalVar = refArr[4].split('?')[1].split('&');
                var hasPartType = false;
                
                for (var i = 0; i < modalVar.length; i++) {
                    if (modalVar[i].split('=')[0] === 'ymm_part_type') {
                        hasPartType = true;
                        break;
                    }
                }
                
                if (hasPartType) {
                    YMMAPI.fetch({
                        type: 'ajax',
                        request: 'application',
                        referrer: referrer
                    }).then(function(data) {
                        if (data && data.length > 0) {
                            var selectedVariantSku = '';
                            var $variantSelect = $('select[data-variants]');
                            if ($variantSelect.length) {
                                selectedVariantSku = $variantSelect.find(':selected').text().trim();
                            }
                            
                            var matchedData = data[0];
                            for (var i = 0; i < data.length; i++) {
                                if (data[i].application_notes && selectedVariantSku.indexOf(data[i].application_notes) !== -1) {
                                    matchedData = data[i];
                                    break;
                                }
                            }
                            
                            if (matchedData.application) {
                                $('.application').html('<div><b>Application </b></div><div>' + matchedData.application + '</div>');
                            }
                            if (matchedData.application_notes) {
                                $('.application_notes').html('<div><b>Application Notes </b></div><div>' + matchedData.application_notes + '</div>');
                            } else {
                                $('.application_notes').html('');
                            }
                            if (matchedData.qty_req) {
                                $('.qty_req').html('<div><b>Qty Req: </b></div><div>' + matchedData.qty_req + '</div>');
                            }
                        }
                    }).catch(function(error) {
                        console.error('Failed to load application data:', error);
                    });
                } else {
                    $('.application').remove();
                    $('.application_notes').remove();
                    $('.qty_req').remove();
                    if ($('.desc-highlight').children().length === 0) {
                        $('.desc-highlight').remove();
                    }
                }
            } else {
                $('.application').remove();
                $('.application_notes').remove();
                $('.qty_req').remove();
                if ($('.desc-highlight').children().length === 0) {
                    $('.desc-highlight').remove();
                }
            }
        },
        
        loadProductPricing: function() {
            var customerId = '';
            var productId = '';
            var productSku = '';
            var productVariants = [];
            var originalPrice = 0;
            
            // Get the add to cart button for enabling/disabling during price load
            var $atcButton = $('.product-form--atc-button');
            var $shopifyPaymentButton = $('.shopify-payment-button');
            
            if (typeof meta !== 'undefined') {
                if (typeof meta.page !== 'undefined' && typeof meta.page.customerId !== 'undefined') {
                    customerId = meta.page.customerId;
                }
                if (typeof meta.product !== 'undefined' && typeof meta.product.id !== 'undefined') {
                    productId = meta.product.id;
                    
                    if (meta.product.variants && meta.product.variants.length > 0) {
                        for (var i = 0; i < meta.product.variants.length; i++) {
                            productVariants[meta.product.variants[i].id] = meta.product.variants[i];
                        }
                    }
                    
                    var selectVariant;
                    var $variantSelect = $('#product_form_' + productId).find('select[data-variants]');
                    if ($variantSelect.length >= 1) {
                        selectVariant = $variantSelect.find(':selected').attr('value');
                    } else {
                        selectVariant = $('#product_form_' + productId).find('input[data-variants]').attr('value');
                    }
                    
                    if (productVariants[selectVariant]) {
                        productSku = productVariants[selectVariant].sku || '';
                        productSku = productSku.replace('_config', '');
                        originalPrice = productVariants[selectVariant].price || 0;
                    }
                }
            }
            
            // If no customer logged in, no API call needed - button stays enabled
            if (!customerId || !productId) return;
            
            // Get the loading placeholder element
            var $priceLoader = $('[data-ymm-price-loader]');
            
            // Check if button was initially hidden (initial page load for logged-in customer)
            var isInitialLoad = $atcButton.hasClass('ymm-price-loading-initial');
            
            // Store original button state before modifying (to handle sold out variants)
            var wasSoldOut = $atcButton.hasClass('disabled') && !$atcButton.hasClass('ymm-price-loading') && !isInitialLoad;
            var originalButtonText = $atcButton.find('.atc-button--text').text().trim() || 'Add to cart';
            
            // Hide the button and show loading placeholder for initial load
            // For subsequent variant changes, show the loader again
            if (isInitialLoad) {
                // Button is already hidden, loader is already visible - nothing to do
            } else {
                // For variant changes, hide button and show loading placeholder again
                $atcButton.addClass('disabled ymm-price-loading').prop('disabled', true).hide();
                $priceLoader.removeClass('ymm-price-loaded');
            }
            $shopifyPaymentButton.hide();
            
            var price = parseFloat(YMMCompat.formatWithDelimiters(originalPrice, 2).replace(/,/g, ''));
            
            // Helper function to re-enable the add to cart button
            var enableAddToCart = function() {
                // Hide the loading placeholder
                $priceLoader.addClass('ymm-price-loaded');
                
                // Show and enable the actual button
                $atcButton.removeClass('ymm-price-loading ymm-price-loading-initial').css('display', '');
                $atcButton.find('.atc-button--text').text(originalButtonText);
                $shopifyPaymentButton.show();
                
                // Only re-enable if the variant wasn't sold out originally
                if (!wasSoldOut) {
                    $atcButton.removeClass('disabled').prop('disabled', false);
                }
            };
            
            YMMAPI.fetch({
                type: 'ajax',
                action: 'getprice',
                product_id: productId,
                customer_id: customerId,
                sku: productSku
            }).then(function(data) {
                // Re-enable add to cart button after pricing loads
                enableAddToCart();
                
                if (!data || data === '') return;
                
                var propertiesHtml = '';
                var $productContainer = $('.product-container-' + productId);
                var $productForm = $('#product_form_' + productId);
                
                if (data.discount_type === 'fixed') {
                    $('.product-main.product-container-' + productId + ' .money-label[data-price-label]').css('display', 'inline-block');
                    
                    if ($productContainer.find('.price__customcurrent').length > 0) {
                        $productContainer.find('.price__customcurrent span.money').html(' $' + parseFloat(data.discount_value).toFixed(2));
                    } else {
                        var customPriceHtml = '<div class="price__customcurrent" data-customprice-container><span class="money-label" data-price-label style="display: inline-block;">Your Price :</span><span class="money" data-price=""> $' + parseFloat(data.discount_value).toFixed(2) + '</span></div>';
                        $productContainer.find('.price__current[data-price-container]').after(customPriceHtml);
                    }
                    
                    if ($productForm.find('input[name="properties[_discountPrice]"]').length >= 1) {
                        $productForm.find('input[name="properties[_discountPrice]"]').val(parseFloat(data.discount_value).toFixed(2));
                    } else {
                        propertiesHtml += '<input type="hidden" name="properties[_discountPrice]" data-property-name="_discountPrice" value="' + parseFloat(data.discount_value).toFixed(2) + '">';
                    }
                    if ($productForm.find('input[name="properties[_discountType]"]').length >= 1) {
                        $productForm.find('input[name="properties[_discountType]"]').val(data.discount_type);
                    } else {
                        propertiesHtml += '<input type="hidden" name="properties[_discountType]" data-property-name="_discountType" value="' + data.discount_type + '">';
                    }
                    if ($productForm.find('input[name="properties[_discountValue]"]').length >= 1) {
                        $productForm.find('input[name="properties[_discountValue]"]').val(data.discount_value);
                    } else {
                        propertiesHtml += '<input type="hidden" name="properties[_discountValue]" data-property-name="_discountValue" value="' + data.discount_value + '">';
                    }
                    $productForm.find('input[name="properties[_discountTag]"]').remove();
                    $productForm.append(propertiesHtml);
                    
                } else if (data.discount_type === 'percentage') {
                    var priceDiscount = price - (price * parseFloat(data.discount_value) / 100);
                    
                    $('.product-main.product-container-' + productId + ' .money-label[data-price-label]').css('display', 'inline-block');
                    
                    if ($productContainer.find('.price__customcurrent').length > 0) {
                        $productContainer.find('.price__customcurrent span.money').html(' $' + parseFloat(priceDiscount).toFixed(2));
                    } else {
                        var customPriceHtml = '<div class="price__customcurrent" data-customprice-container><span class="money-label" data-price-label style="display: inline-block;">Your Price :</span><span class="money" data-price=""> $' + parseFloat(priceDiscount).toFixed(2) + '</span></div>';
                        $productContainer.find('.price__current[data-price-container]').after(customPriceHtml);
                    }
                    
                    if ($productForm.find('input[name="properties[_discountPrice]"]').length >= 1) {
                        $productForm.find('input[name="properties[_discountPrice]"]').val(parseFloat(priceDiscount).toFixed(2));
                    } else {
                        propertiesHtml += '<input type="hidden" name="properties[_discountPrice]" data-property-name="_discountPrice" value="' + parseFloat(priceDiscount).toFixed(2) + '">';
                    }
                    if ($productForm.find('input[name="properties[_discountType]"]').length >= 1) {
                        $productForm.find('input[name="properties[_discountType]"]').val(data.discount_type);
                    } else {
                        propertiesHtml += '<input type="hidden" name="properties[_discountType]" data-property-name="_discountType" value="' + data.discount_type + '">';
                    }
                    if ($productForm.find('input[name="properties[_discountValue]"]').length >= 1) {
                        $productForm.find('input[name="properties[_discountValue]"]').val(data.discount_value);
                    } else {
                        propertiesHtml += '<input type="hidden" name="properties[_discountValue]" data-property-name="_discountValue" value="' + data.discount_value + '">';
                    }
                    if (data.tag) {
                        propertiesHtml += '<input type="hidden" name="properties[_discountTag]" data-property-name="_discountTag" value="' + data.tag + '">';
                    }
                    $productForm.append(propertiesHtml);
                }
            }).catch(function(error) {
                console.error('Failed to load product pricing:', error);
                // Re-enable add to cart button even if pricing API fails
                // User can still add to cart at original price
                enableAddToCart();
            });
        },
        
        loadCompatibilityData: function() {
            var productId = $('.shop_product_id').val();
            if (!productId) return;
            
            var $tbody = $('.compatibility-table');
            $tbody.html('<tr><td colspan="5" class="loading-spin"><img src="https://cdn.shopify.com/s/files/1/0281/6924/0651/t/12/assets/spinner.gif" alt="Loading..." width="48" height="48"></td></tr>');
            
            YMMAPI.fetch({
                type: 'ajax',
                request: 'compatibility',
                product: productId,
                format: 'json'
            }).then(function(data) {
                if (!data || !data.length) {
                    $tbody.html('<tr><td colspan="5">No compatibility data found</td></tr>');
                    return;
                }
                
                var html = '';
                for (var i = 0; i < data.length; i++) {
                    html += '<tr>';
                    html += '<td>' + (data[i].value_name4 || '-') + '</td>';
                    html += '<td>' + (data[i].value_name3 || '-') + '</td>';
                    html += '<td>' + (data[i].value_name2 || '-') + '</td>';
                    html += '<td>' + (data[i].value_name1 || '-') + '</td>';
                    html += '<td>' + (data[i].value_name || '-') + '</td>';
                    html += '</tr>';
                }
                
                $tbody.html(html);
            }).catch(function(error) {
                console.error('Failed to load product compatibility:', error);
                $tbody.html('<tr><td colspan="5">Failed to load compatibility data</td></tr>');
            });
        },
        
        initCatalogPage: function() {
            var self = this;
            YMMDropdown.initialize();
            
            var hasYMMParams = YMMUtils.hasYMMParams();
            
            if (hasYMMParams) {
                var params = YMMUtils.getYMMParams();
                
                // Update pagination UI immediately based on URL params
                YMMProductRenderer.updatePaginationUI(params.pageLimit);
                
                setTimeout(function() {
                    YMMProductRenderer.render(params);
                }, 100);
            } else {
                self.loadAllCatalogProducts();
            }
        },
        
        loadAllCatalogProducts: function() {
            var customerId = YMMUtils.getCustomerId();
            var pageNo = parseInt(YMMUtils.getUrlParam('p')) || YMMConfig.defaults.pageNo;
            var pageLimit = parseInt(YMMUtils.getUrlParam('product_limit')) || YMMConfig.defaults.pageLimit;
            var viewMode = YMMUtils.getCurrentViewMode();
            
            $(YMMConfig.selectors.loader).css('display', 'flex');
            
            YMMAPI.getAllProducts({
                pageLimit: pageLimit,
                pageNo: pageNo,
                customerId: customerId
            }).then(function(data) {
                if (!data || !data.products) {
                    // Remove loading class to show pagination (prevents CLS)
                    $('.productgrid--outer').removeClass('catalog-page-loading');
                    $(YMMConfig.selectors.loader).css('display', 'none');
                    return;
                }
                
                var products = data.products;
                var count = parseInt(data.count) || 0;
                var totalPages = parseInt(data.total_pages) || 1;
                var currentPage = parseInt(data.page_no) || pageNo;
                
                if (YMMConfig.hideZeroPrice) {
                    var initialLen = products.length;
                    products = products.filter(function(product) {
                        var price = 0;
                        if (product.pricelist && typeof product.pricelist.final_price !== 'undefined' && product.pricelist.final_price !== null) {
                            price = parseFloat(product.pricelist.final_price);
                        } else if (product.price) {
                            price = parseFloat(product.price);
                        }
                        return !isNaN(price) && price > 0;
                    });
                    
                    var removedCount = initialLen - products.length;
                    if (removedCount > 0) {
                        count = Math.max(0, count - removedCount);
                    }
                }
                
                if (YMMConfig.hideOos) {
                    var initialLenOos = products.length;
                    products = products.filter(function(product) {
                        var inStock = parseInt(product.in_stock);
                        var qty = parseInt(product.quantity);
                        return (!isNaN(inStock) && inStock > 0) || (!isNaN(qty) && qty > 0);
                    });
                    
                    var removedCountOos = initialLenOos - products.length;
                    if (removedCountOos > 0) {
                        count = Math.max(0, count - removedCountOos);
                    }
                }
                
                var $container = $(YMMConfig.selectors.productContainer);
                if (!$container.length) {
                    $container = $('.collection-products');
                }
                
                if (!products.length) {
                    $container.html(YMMTemplates.noProducts());
                    $(YMMConfig.selectors.pagination).html('');
                    $(YMMConfig.selectors.paginateInfo).html('0 items');
                    
                    // Remove loading class to show pagination (prevents CLS)
                    $('.productgrid--outer').removeClass('catalog-page-loading');
                    $(YMMConfig.selectors.loader).css('display', 'none');
                    return;
                }
                
                var rangeContent = '';
                if (count === 1) {
                    rangeContent = count + ' item';
                } else if (count <= pageLimit) {
                    rangeContent = count + ' items';
                } else {
                    var range = pageLimit * currentPage;
                    rangeContent = ((range - pageLimit) + 1) + '-' + Math.min(range, count) + ' of ' + count;
                }
                $(YMMConfig.selectors.paginateInfo).html(rangeContent);
                
                var isLoggedIn = YMMUtils.isLoggedIn();
                var uqCount = Math.floor(Math.random() * 50000);
                var html = '';
                
                for (var i = 0; i < products.length; i++) {
                    uqCount++;
                    var product = products[i];
                    
                    window.ymm_items[product.product_id] = product;
                    
                    var options = {
                        isLoggedIn: isLoggedIn,
                        uqId: uqCount,
                        searchString: '',
                        viewMode: viewMode,
                        isFirstProduct: i === 0
                    };
                    
                    if (product.in_stock < 1) {
                        html += YMMTemplates.productOutOfStock(product, options);
                    } else if (viewMode === 'grid-view') {
                        html += YMMTemplates.productGridItem(product, options);
                    } else {
                        html += YMMTemplates.productListItem(product, options);
                    }
                }
                
                $container.html(html);
                
                var paginationParams = {
                    pageLimit: pageLimit,
                    viewMode: viewMode
                };
                var paginationHtml = YMMTemplates.pagination(currentPage, totalPages, paginationParams);
                $(YMMConfig.selectors.pagination).html(paginationHtml);
                
                // Update pagination UI with dynamic options based on total count
                YMMProductRenderer.updatePaginationUI(pageLimit, count);
                
                // Remove loading class to show pagination (prevents CLS)
                $('.productgrid--outer').removeClass('catalog-page-loading');
                
                if (typeof window.catalogImageFallback === 'function') {
                    setTimeout(function() {
                        window.catalogImageFallback();
                    }, 250);
                }
                
                if (typeof window.catalogBundleGraphQL !== 'undefined' && typeof window.catalogBundleManager !== 'undefined') {
                    var productIds = [];
                    $(".productgrid--items [attr-prod-id]").each(function() {
                        var prodId = $(this).attr("attr-prod-id");
                        if (prodId && productIds.indexOf(prodId) === -1) {
                            productIds.push(prodId);
                        }
                    });
                    
                    if (productIds.length > 0) {
                        var productsForBundle = productIds.map(function(id) {
                            return { product_id: id };
                        });
                        window.catalogBundleGraphQL.fetchBundleData(productsForBundle, 'catalog');
                    }
                }
                
                $(YMMConfig.selectors.loader).css('display', 'none');
                
            }).catch(function(error) {
                console.error('Failed to load catalog products:', error);
                
                // Remove loading class to show pagination (prevents CLS)
                $('.productgrid--outer').removeClass('catalog-page-loading');
                
                $(YMMConfig.selectors.loader).css('display', 'none');
            });
        },
        
        renderProducts: function(params) {
            YMMProductRenderer.render(params);
        },
        
        navigateToCatalog: function() {
            YMMDropdown.navigateToCatalog();
        },
        
        resetDropdowns: function() {
            YMMDropdown.reset();
        }
    };

    var YMMDebug = {
        enabled: false,
        
        enable: function() {
            this.enabled = true;
            this.log('Debug mode enabled');
        },
        
        disable: function() {
            this.log('Debug mode disabled');
            this.enabled = false;
        },
        
        log: function() {
            if (this.enabled && console && console.log) {
                var args = Array.prototype.slice.call(arguments);
                args.unshift('[YMM]');
                console.log.apply(console, args);
            }
        },
        
        warn: function() {
            if (this.enabled && console && console.warn) {
                var args = Array.prototype.slice.call(arguments);
                args.unshift('[YMM]');
                console.warn.apply(console, args);
            }
        },
        
        error: function() {
            if (console && console.error) {
                var args = Array.prototype.slice.call(arguments);
                args.unshift('[YMM]');
                console.error.apply(console, args);
            }
        },
        
        getState: function() {
            return {
                initialized: YMMApp.initialized,
                dropdownState: YMMDropdown.state,
                currentViewMode: YMMViewToggle.currentMode,
                urlParams: YMMUtils.getYMMParams(),
                isLoggedIn: YMMUtils.isLoggedIn(),
                customerId: YMMUtils.getCustomerId(),
                page: {
                    isHome: YMMUtils.isHomePage(),
                    isCatalog: YMMUtils.isCatalogPage(),
                    isProduct: YMMUtils.isProductPage(),
                    isSearch: YMMUtils.isSearchPage()
                }
            };
        }
    };

    var YMMVersion = {
        version: '2.0.0',
        buildDate: '2024-12-19',
        
        info: function() {
            return {
                version: this.version,
                buildDate: this.buildDate,
                modules: [
                    'YMMConfig',
                    'YMMAPI',
                    'YMMUtils',
                    'YMMDropdown',
                    'YMMTemplates',
                    'YMMProductRenderer',
                    'YMMCart',
                    'YMMBuyersGuide',
                    'YMMRecentSearches',
                    'YMMViewToggle',
                    'YMMEvents',
                    'YMMApp',
                    'YMMDebug'
                ]
            };
        }
    };

    var YMMCompat = {
        ymm_items: {},
        option_data_fields_arr: {},
        skulist: YMMConfig.configurablePrefixes,
        
        isNumber: function(evt) {
            evt = evt || window.event;
            var charCode = evt.which || evt.keyCode;
            if (charCode > 31 && (charCode < 48 || charCode > 57)) {
                return false;
            }
            return true;
        },
        
        percentage: function(num, percent) {
            return (num / 100) * percent;
        },
        
        formatWithDelimiters: function(number, precision, thousands, decimal) {
            precision = precision === undefined ? 2 : precision;
            thousands = thousands || ',';
            decimal = decimal || '.';
            
            if (isNaN(number) || number == null) {
                return '0';
            }
            
            number = (number / 100.0).toFixed(precision);
            
            var parts = number.split('.');
            var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
            var cents = parts[1] ? decimal + parts[1] : '';
            
            return dollars + cents;
        },
        
        get_variant_location: function() {
            return true;
        },
        
        closeDropdown: function() {
            $('.form-group.active').removeClass('active');
        }
    };

    window.YMMConfig = YMMConfig;
    window.YMMAPI = YMMAPI;
    window.YMMUtils = YMMUtils;
    window.YMMDropdown = YMMDropdown;
    window.YMMTemplates = YMMTemplates;
    window.YMMProductRenderer = YMMProductRenderer;
    window.YMMCart = YMMCart;
    window.YMMBuyersGuide = YMMBuyersGuide;
    window.YMMRecentSearches = YMMRecentSearches;
    window.YMMViewToggle = YMMViewToggle;
    window.YMMEvents = YMMEvents;
    window.YMMApp = YMMApp;
    window.YMMDebug = YMMDebug;
    window.YMMVersion = YMMVersion;
    window.YMMCompat = YMMCompat;

    window.ymm_items = YMMCompat.ymm_items;
    window.option_data_fields_arr = YMMCompat.option_data_fields_arr;
    window.skulist = YMMCompat.skulist;
    window.isNumber = YMMCompat.isNumber;
    window.percentage = YMMCompat.percentage;
    window.formatWithDelimiters = YMMCompat.formatWithDelimiters;
    window.get_variant_location = YMMCompat.get_variant_location;
    window.closeDropdown = YMMCompat.closeDropdown;

    if (typeof window.YMM_AUTO_INIT === 'undefined' || window.YMM_AUTO_INIT !== false) {
        YMMApp.init();
    }

})(jQuery);
